// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chats-page {
  --chat-page-bg:
    radial-gradient(circle at top left, rgba(255, 255, 255, 0.42), transparent 28%),
    linear-gradient(180deg, #6cb7ff 0%, #58a5f4 38%, #4798e9 100%);
  --chat-shell-surface: rgba(245, 249, 255, 0.78);
  --chat-shell-border: rgba(255, 255, 255, 0.46);
  --chat-shell-shadow: 0 22px 60px rgba(15, 58, 109, 0.16);
  --chat-text: #122338;
  --chat-muted: #6282a4;
  --chat-strong: #0f2843;
  --chat-soft-surface: rgba(255, 255, 255, 0.88);
  --chat-soft-surface-2: rgba(255, 255, 255, 0.92);
  --chat-soft-hover: rgba(255, 255, 255, 0.52);
  --chat-active: rgba(255, 255, 255, 0.88);
  --chat-active-ring: inset 0 0 0 1px rgba(63, 144, 224, 0.18);
  --chat-header-bg: rgba(234, 244, 255, 0.82);
  --chat-header-border: rgba(25, 71, 116, 0.08);
  --chat-panel-bg:
    linear-gradient(rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.12)),
    radial-gradient(circle at top left, rgba(255, 255, 255, 0.2), transparent 22%);
  --chat-bubble-other: rgba(255, 255, 255, 0.96);
  --chat-bubble-mine: linear-gradient(180deg, #42a6ff, #1b86ef);
  --chat-composer-bg: rgba(255, 255, 255, 0.88);
  --chat-modal-bg: #f4f9ff;
  --chat-modal-overlay: rgba(11, 32, 56, 0.32);
  min-height: 100vh;
  background: var(--chat-page-bg);
  color: var(--chat-text);
  font-family: "Manrope", "Segoe UI", sans-serif;
}

/* Telegram-like regular chat overrides */
.chats-page {
  --tg-bg: #e7eef5;
  --tg-sidebar: #ffffff;
  --tg-panel: #ffffff;
  --tg-header: rgba(255, 255, 255, 0.96);
  --tg-border: #dfe7ef;
  --tg-text: #17212b;
  --tg-muted: #6f8396;
  --tg-accent: #2aabee;
  --tg-bubble-other: #ffffff;
  --tg-bubble-mine: #effdde;
  min-height: 100dvh;
  background: var(--tg-bg);
  color: var(--tg-text);
}

body[data-theme="dark"] .chats-page {
  --tg-bg: #0e1621;
  --tg-sidebar: #17212b;
  --tg-panel: #17212b;
  --tg-header: rgba(23, 33, 43, 0.96);
  --tg-border: #263542;
  --tg-text: #eef6fc;
  --tg-muted: #8aa0b3;
  --tg-bubble-other: #182533;
  --tg-bubble-mine: #2b5278;
}

.chats-shell {
  grid-template-columns: minmax(300px, 368px) minmax(0, 1fr);
  gap: 0;
  max-width: none;
  min-height: 100dvh;
  padding: 0;
}

.chats-sidebar,
.chats-main {
  border: 0;
  border-radius: 0;
  box-shadow: none;
  backdrop-filter: none;
}

.chats-sidebar {
  background: var(--tg-sidebar);
  border-right: 1px solid var(--tg-border);
}

.chats-main {
  background:
    linear-gradient(rgba(231, 238, 245, 0.84), rgba(231, 238, 245, 0.84)),
    repeating-linear-gradient(45deg, rgba(42, 171, 238, 0.04) 0 1px, transparent 1px 18px);
}

body[data-theme="dark"] .chats-main {
  background:
    linear-gradient(rgba(14, 22, 33, 0.9), rgba(14, 22, 33, 0.9)),
    repeating-linear-gradient(45deg, rgba(255, 255, 255, 0.025) 0 1px, transparent 1px 18px);
}

.chats-sidebar-top,
.chats-header,
.pinned-message-bar {
  background: var(--tg-header);
  border-bottom: 1px solid var(--tg-border);
}

.chats-brand {
  display: none;
}

.chats-filter-row {
  display: flex;
  gap: 8px;
  overflow: auto;
  padding: 0 14px 10px;
}

.chat-filter-chip {
  border: 1px solid var(--tg-border);
  border-radius: 999px;
  background: transparent;
  color: var(--tg-muted);
  padding: 8px 10px;
  display: inline-flex;
  gap: 6px;
}

.chat-filter-chip.active {
  color: var(--tg-accent);
  background: rgba(42, 171, 238, 0.12);
}

.chat-row {
  border-radius: 0;
  border: 0;
}

.chat-row-pin,
.message-pin-mark {
  display: inline-flex;
  width: 14px;
  height: 14px;
  color: var(--tg-accent);
}

.chat-row-pin.important,
.message-pin-mark.important {
  color: #e8a800;
}

.pinned-message-bar {
  width: 100%;
  border-left: 0;
  border-right: 0;
  border-top: 0;
  color: var(--tg-text);
  display: grid;
  grid-template-columns: 32px minmax(0, 1fr);
  gap: 8px;
  padding: 8px 18px;
  text-align: left;
}

.pinned-message-icon {
  color: var(--tg-accent);
}

.pinned-message-copy {
  display: grid;
  min-width: 0;
}

.pinned-message-copy strong,
.pinned-message-copy span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.message-bubble.other {
  background: var(--tg-bubble-other);
}

.message-bubble.mine {
  background: var(--tg-bubble-mine);
  color: var(--tg-text);
}

.message-reply-preview,
.message-forwarded,
.link-preview-card {
  border-left: 3px solid var(--tg-accent);
  background: rgba(42, 171, 238, 0.08);
  border-radius: 7px;
  padding: 6px 8px;
  margin-bottom: 6px;
}

.message-forwarded {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: var(--tg-muted);
  font-size: 12px;
}

.message-text {
  overflow-wrap: anywhere;
}

.message-text code {
  border-radius: 5px;
  padding: 1px 4px;
  background: rgba(0, 0, 0, 0.08);
}

.message-text pre {
  overflow: auto;
  border-radius: 8px;
  padding: 8px;
  background: rgba(0, 0, 0, 0.08);
}

.link-preview-card {
  display: grid;
  text-decoration: none;
}

.link-preview-domain {
  color: var(--tg-accent);
  font-weight: 700;
}

.link-preview-url {
  color: var(--tg-muted);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.message-reactions,
.reaction-row {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 6px;
}

.message-reaction,
.reaction-choice {
  border: 0;
  border-radius: 999px;
  background: rgba(42, 171, 238, 0.14);
  padding: 4px 8px;
}

.reaction-choice {
  font-size: 18px;
  width: 38px;
  height: 34px;
}

.composer {
  background: transparent;
}

/* Support /chats final native lock. Kept at EOF to override the older desktop card skin above. */
.pageContentInner:has(> .chats-page) {
  padding: 0 !important;
}

.chats-page {
  --tg-bg: #dbe7f3;
  --tg-sidebar: #fff;
  --tg-panel: #fff;
  --tg-header: #fff;
  --tg-border: #d3dde8;
  --tg-text: #17212b;
  --tg-muted: #6d7f90;
  --tg-accent: #2aabee;
  --tg-bubble-other: #fff;
  --tg-bubble-mine: #dff7c7;
  --tg-input: #fff;
  --tg-skeleton-base: rgba(23, 33, 43, .08);
  --tg-skeleton-peak: rgba(255, 255, 255, .72);
  width: 100% !important;
  height: calc(var(--vh, 1vh) * 100) !important;
  min-height: 0 !important;
  overflow: hidden !important;
  background: var(--tg-bg) !important;
  color: var(--tg-text) !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif !important;
}

body[data-theme="dark"] .chats-page {
  --tg-bg: #0e1621;
  --tg-sidebar: #17212b;
  --tg-panel: #17212b;
  --tg-header: #17212b;
  --tg-border: #0b1118;
  --tg-text: #eef6fc;
  --tg-muted: #7f91a4;
  --tg-bubble-other: #182533;
  --tg-bubble-mine: #2b5278;
  --tg-input: #242f3d;
  --tg-skeleton-base: rgba(255, 255, 255, .07);
  --tg-skeleton-peak: rgba(255, 255, 255, .16);
}

.chats-shell {
  width: 100% !important;
  height: 100% !important;
  min-height: 0 !important;
  display: grid !important;
  grid-template-columns: 360px minmax(0, 1fr) !important;
  gap: 0 !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
}

.chats-sidebar,
.chats-main {
  min-height: 0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
}

.chats-sidebar {
  display: flex !important;
  flex-direction: column !important;
  padding: 0 !important;
  gap: 0 !important;
  overflow: hidden !important;
  background: var(--tg-sidebar) !important;
  border-right: 1px solid var(--tg-border) !important;
}

.chats-main {
  position: relative !important;
  display: grid !important;
  grid-template-rows: 56px auto minmax(0, 1fr) auto !important;
  overflow: hidden !important;
  background:
    linear-gradient(rgba(219, 231, 243, .84), rgba(219, 231, 243, .84)),
    radial-gradient(circle at 24px 24px, rgba(49, 102, 139, .075) 0 1.2px, transparent 1.4px),
    radial-gradient(circle at 76px 84px, rgba(49, 102, 139, .055) 0 1.6px, transparent 1.8px) !important;
  background-size: auto, 68px 68px, 112px 112px !important;
}

body[data-theme="dark"] .chats-main {
  background:
    linear-gradient(rgba(14, 22, 33, .9), rgba(14, 22, 33, .9)),
    radial-gradient(circle at 24px 24px, rgba(255, 255, 255, .045) 0 1.2px, transparent 1.4px),
    radial-gradient(circle at 76px 84px, rgba(255, 255, 255, .035) 0 1.6px, transparent 1.8px) !important;
}

.chats-sidebar-top,
.chats-header {
  height: 56px !important;
  min-height: 56px !important;
  padding: 0 12px !important;
  background: var(--tg-header) !important;
  border-bottom: 1px solid var(--tg-border) !important;
}

.chats-brand {
  display: none !important;
}

.chats-sidebar-title {
  color: var(--tg-text) !important;
  font-size: 19px !important;
  font-weight: 700 !important;
}

.round-action,
.icon-button,
.composer-tool,
.jump-to-bottom,
.message-action-button {
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  border: 0 !important;
  border-radius: 50% !important;
  color: var(--tg-muted) !important;
  background: transparent !important;
  box-shadow: none !important;
}

.round-action:hover,
.icon-button:hover,
.icon-button.active,
.composer-tool:hover {
  color: var(--tg-accent) !important;
  background: rgba(42, 171, 238, .12) !important;
}

.chats-search-wrap,
.chats-filter-row {
  background: var(--tg-sidebar) !important;
}

.chats-search {
  height: 36px !important;
  border: 0 !important;
  border-radius: 18px !important;
  background: var(--tg-input) !important;
}

.chat-filter-chip {
  min-height: 30px !important;
  border: 0 !important;
  border-radius: 15px !important;
  color: var(--tg-muted) !important;
  background: transparent !important;
}

.chat-filter-chip.active {
  color: var(--tg-accent) !important;
  background: rgba(42, 171, 238, .14) !important;
}

.chats-list {
  flex: 1 1 !important;
  min-height: 0 !important;
  gap: 0 !important;
  padding: 0 !important;
  overflow: auto !important;
  background: var(--tg-sidebar) !important;
}

.chat-row,
.chat-row-skeleton {
  position: relative !important;
  width: 100% !important;
  min-height: 72px !important;
  border: 0 !important;
  border-radius: 0 !important;
  grid-template-columns: 54px minmax(0, 1fr) auto !important;
  gap: 10px !important;
  padding: 8px 12px !important;
  color: var(--tg-text) !important;
  background: transparent !important;
}

.chat-row::after,
.chat-row-skeleton::after {
  content: "" !important;
  position: absolute !important;
  left: 76px !important;
  right: 0 !important;
  bottom: 0 !important;
  height: 1px !important;
  background: rgba(23, 33, 43, .08) !important;
}

.chat-row:hover {
  background: rgba(42, 171, 238, .07) !important;
}

.chat-row.active {
  background: rgba(42, 171, 238, .14) !important;
}

.chat-avatar,
.skeleton-avatar {
  width: 50px !important;
  height: 50px !important;
  border-radius: 50% !important;
}

.chat-row-title {
  color: var(--tg-text) !important;
  font-size: 15px !important;
  font-weight: 600 !important;
}

.chat-row-preview,
.chat-row-time {
  color: var(--tg-muted) !important;
  font-size: 13px !important;
}

.messages-panel {
  min-height: 0 !important;
  padding: 14px max(12px, calc((100% - 920px) / 2)) 10px !important;
  overflow: auto !important;
  scroll-behavior: smooth !important;
}

.messages-date-divider span {
  min-height: 26px !important;
  border-radius: 13px !important;
  padding: 0 12px !important;
  background: rgba(109, 127, 144, .58) !important;
  backdrop-filter: blur(8px) !important;
}

.message-row.mine {
  align-items: flex-end !important;
}

.message-row.other {
  align-items: flex-start !important;
}

.message-bubble {
  max-width: min(620px, 78%) !important;
  border: 0 !important;
  border-radius: 11px !important;
  padding: 6px 8px 4px !important;
  color: var(--tg-text) !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .18) !important;
  animation: telegram-message-in .2s cubic-bezier(.18, .9, .22, 1.12) both !important;
}

.message-bubble.other {
  border-bottom-left-radius: 3px !important;
  background: var(--tg-bubble-other) !important;
}

.message-bubble.mine {
  border-bottom-right-radius: 3px !important;
  background: var(--tg-bubble-mine) !important;
}

.message-text {
  color: var(--tg-text) !important;
  font-size: 16px !important;
  line-height: 1.36 !important;
}

.composer {
  position: sticky !important;
  bottom: 0 !important;
  z-index: 4 !important;
  border: 0 !important;
  padding: 7px max(8px, calc((100% - 940px) / 2)) 10px !important;
  background: linear-gradient(180deg, rgba(219, 231, 243, 0), rgba(219, 231, 243, .96) 22%) !important;
}

.composer-shell {
  width: 100% !important;
  max-width: none !important;
  border: 0 !important;
  border-radius: 0 !important;
  display: grid !important;
  grid-template-columns: 40px 40px minmax(0, 1fr) 40px 46px !important;
  align-items: end !important;
  gap: 6px !important;
  margin: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.composer-input {
  min-height: 42px !important;
  max-height: 140px !important;
  border: 0 !important;
  border-radius: 21px !important;
  resize: none !important;
  padding: 11px 14px !important;
  background: var(--tg-input) !important;
  color: var(--tg-text) !important;
  font-size: 15px !important;
}

.composer-send {
  width: 44px !important;
  height: 44px !important;
  min-width: 44px !important;
  border: 0 !important;
  border-radius: 50% !important;
  background: var(--tg-accent) !important;
  color: #fff !important;
  box-shadow: none !important;
}

.composer-editing,
.composer-attachments,
.emoji-panel {
  grid-column: 1 / -1 !important;
}

.jump-to-bottom {
  position: absolute !important;
  right: max(16px, calc((100% - 920px) / 2)) !important;
  bottom: 74px !important;
  z-index: 8 !important;
  background: var(--tg-panel) !important;
  box-shadow: 0 4px 14px rgba(23, 33, 43, .18) !important;
}

.chats-empty {
  border-radius: 14px !important;
  padding: 16px 18px !important;
  color: var(--tg-muted) !important;
  background: rgba(255, 255, 255, .78) !important;
}

.settings-status {
  color: var(--tg-muted);
  font-size: 13px;
  padding: 0 4px;
}

.settings-mute-options,
.settings-counters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.chat-sheet,
.chats-modal {
  position: fixed !important;
  inset: 0 !important;
  z-index: 2000 !important;
  display: grid !important;
  place-items: end center !important;
  padding: 0 10px calc(10px + env(safe-area-inset-bottom)) !important;
  background: rgba(0, 0, 0, .52) !important;
  backdrop-filter: blur(14px) !important;
}

.attachment-sheet-grid {
  width: min(430px, 100%) !important;
  max-height: 82dvh !important;
  overflow: auto !important;
  border-radius: 18px !important;
  display: grid !important;
  grid-template-columns: repeat(3, 1fr) !important;
  gap: 20px 12px !important;
  padding: 28px 18px 24px !important;
  color: #fff !important;
  background: rgba(33, 35, 39, .96) !important;
}

.attachment-sheet-grid button {
  border: 0 !important;
  display: grid !important;
  justify-items: center !important;
  gap: 8px !important;
  color: #fff !important;
  background: transparent !important;
}

.attachment-sheet-icon {
  width: 52px !important;
  height: 52px !important;
  border-radius: 50% !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #fff !important;
}

.attachment-sheet-icon.blue { background: linear-gradient(135deg, #2f80ed, #3b9bff) !important; }
.attachment-sheet-icon.purple { background: linear-gradient(135deg, #7c3aed, #a855f7) !important; }
.attachment-sheet-icon.orange { background: linear-gradient(135deg, #f59e0b, #fb923c) !important; }

.attachment-sheet-cancel {
  width: min(430px, 100%) !important;
  min-height: 54px !important;
  border: 0 !important;
  border-radius: 14px !important;
  color: var(--tg-accent) !important;
  background: rgba(33, 35, 39, .96) !important;
  font-size: 16px !important;
}

.skeleton-avatar,
.skeleton-line,
.skeleton-date-pill,
.message-skeleton-bubble {
  position: relative !important;
  overflow: hidden !important;
  background: var(--tg-skeleton-base) !important;
}

.skeleton-avatar::after,
.skeleton-line::after,
.skeleton-date-pill::after,
.message-skeleton-bubble::after {
  content: "" !important;
  position: absolute !important;
  inset: 0 !important;
  transform: translateX(-100%) !important;
  background: linear-gradient(90deg, transparent, var(--tg-skeleton-peak), transparent) !important;
  animation: skeleton-shimmer 1.25s ease-in-out infinite !important;
}

.message-skeleton-bubble {
  width: min(360px, 68%) !important;
  min-height: 56px !important;
  border-radius: 13px !important;
  display: grid !important;
  align-content: center !important;
  gap: 8px !important;
  padding: 12px !important;
}

.message-skeleton-bubble.other {
  align-self: flex-start !important;
}

.message-skeleton-bubble.mine {
  align-self: flex-end !important;
  background: rgba(91, 185, 74, .16) !important;
}

.message-skeleton-bubble.wide {
  width: min(470px, 78%) !important;
}

@media (max-width: 760px) {
  .chats-shell {
    height: 100% !important;
    grid-template-columns: 1fr !important;
  }

  .chats-sidebar.hidden,
  .chats-main.hidden {
    display: none !important;
  }

  .chats-sidebar {
    border-right: 0 !important;
  }

  .chats-main {
    height: 100% !important;
    grid-template-rows: 56px auto minmax(0, 1fr) auto !important;
  }

  .header-actions .optional-mobile-action {
    display: none !important;
  }

  .messages-panel {
    padding: 10px 8px 8px !important;
  }

  .message-bubble {
    max-width: 86% !important;
  }

  .composer {
    padding: 6px 8px calc(8px + env(safe-area-inset-bottom)) !important;
  }

  .composer-shell {
    grid-template-columns: 38px 38px minmax(0, 1fr) 38px 44px !important;
    align-items: center !important;
  }
}

.call-header-button {
  color: #0b8f4d !important;
}

.call-header-button.active {
  background: rgba(39, 167, 231, 0.14) !important;
  color: #0088cc !important;
}

.chat-call-panel {
  margin: 10px 14px 0 !important;
  padding: 12px !important;
  display: grid !important;
  grid-template-columns: 42px minmax(0, 1fr) auto !important;
  align-items: center !important;
  gap: 12px !important;
  border: 1px solid rgba(39, 167, 231, 0.18) !important;
  border-radius: 18px !important;
  background: rgba(255, 255, 255, 0.96) !important;
  box-shadow: 0 8px 24px rgba(18, 44, 74, 0.08) !important;
  color: #111 !important;
}

.chat-call-panel.incoming {
  border-color: rgba(11, 143, 77, 0.24) !important;
  background: linear-gradient(180deg, #fff, #f2fbf7) !important;
}

.chat-call-panel.active {
  background: linear-gradient(180deg, #fff, #f0f9ff) !important;
}

.chat-call-panel.connected {
  border-color: rgba(11, 143, 77, 0.28) !important;
}

.chat-call-panel.failed {
  border-color: rgba(219, 67, 67, 0.26) !important;
  background: linear-gradient(180deg, #fff, #fff4f4) !important;
}

.chat-call-avatar {
  width: 42px !important;
  height: 42px !important;
  border-radius: 21px !important;
  display: grid !important;
  place-items: center !important;
  background: #27a7e7 !important;
  color: #fff !important;
}

.chat-call-panel.incoming .chat-call-avatar,
.chat-call-panel.connected .chat-call-avatar {
  background: #0b8f4d !important;
}

.chat-call-panel.failed .chat-call-avatar {
  background: #d84444 !important;
}

.chat-call-copy {
  min-width: 0 !important;
  display: grid !important;
  gap: 3px !important;
}

.chat-call-copy strong {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  font-size: 14px !important;
  font-weight: 800 !important;
  color: #111 !important;
}

.chat-call-copy span {
  overflow: hidden !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
  font-size: 13px !important;
  color: #707579 !important;
}

.chat-call-actions {
  display: flex !important;
  align-items: center !important;
  gap: 8px !important;
}

.call-action {
  min-height: 38px !important;
  padding: 0 12px !important;
  border: 0 !important;
  border-radius: 19px !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  gap: 7px !important;
  font-size: 13px !important;
  font-weight: 800 !important;
  cursor: pointer !important;
}

.call-action.accept {
  background: #0b8f4d !important;
  color: #fff !important;
}

.call-action.decline {
  background: #e94b4b !important;
  color: #fff !important;
}

.call-action.muted {
  background: #f1f3f5 !important;
  color: #111 !important;
}

.call-action.muted.active {
  background: #fff0f0 !important;
  color: #d84444 !important;
}

.call-action:disabled {
  opacity: 0.56 !important;
  cursor: default !important;
}

.chat-call-sound {
  width: fit-content !important;
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
  color: #0088cc !important;
  font-size: 12px !important;
  font-weight: 800 !important;
  text-align: left !important;
  cursor: pointer !important;
}

@media (max-width: 760px) {
  .chat-call-panel {
    margin: 8px 8px 0 !important;
    grid-template-columns: 38px minmax(0, 1fr) !important;
  }

  .chat-call-actions {
    grid-column: 1 / -1 !important;
    justify-content: stretch !important;
  }

  .call-action {
    flex: 1 1 !important;
  }
}

/* Native Telegram-like final pass for ordinary /chats */
.pageContentInner:has(> .chats-page) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.chats-page {
  --tg-bg: #dbe7f3;
  --tg-sidebar: #fff;
  --tg-panel: #fff;
  --tg-header: #fff;
  --tg-border: #d3dde8;
  --tg-text: #17212b;
  --tg-muted: #6d7f90;
  --tg-accent: #2aabee;
  --tg-bubble-other: #fff;
  --tg-bubble-mine: #dff7c7;
  --tg-bubble-mine-border: #c9edaa;
  --tg-input: #fff;
  --tg-skeleton-base: rgba(23, 33, 43, .08);
  --tg-skeleton-peak: rgba(255, 255, 255, .72);
  width: 100%;
  height: calc(var(--vh, 1vh) * 100);
  min-height: 0;
  overflow: hidden;
  background: var(--tg-bg);
  color: var(--tg-text);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif;
}

body[data-theme="dark"] .chats-page {
  --tg-bg: #0e1621;
  --tg-sidebar: #17212b;
  --tg-panel: #17212b;
  --tg-header: #17212b;
  --tg-border: #0b1118;
  --tg-text: #eef6fc;
  --tg-muted: #7f91a4;
  --tg-bubble-other: #182533;
  --tg-bubble-mine: #2b5278;
  --tg-bubble-mine-border: #2b5278;
  --tg-input: #242f3d;
  --tg-skeleton-base: rgba(255, 255, 255, .07);
  --tg-skeleton-peak: rgba(255, 255, 255, .16);
}

.chats-shell {
  width: 100%;
  height: 100%;
  min-height: 0;
  display: grid;
  grid-template-columns: 360px minmax(0, 1fr);
  gap: 0;
  padding: 0;
  margin: 0;
  overflow: hidden;
}

.chats-sidebar,
.chats-main {
  min-height: 0;
  border: 0;
  border-radius: 0;
  box-shadow: none;
  backdrop-filter: none;
}

.chats-sidebar {
  display: flex;
  flex-direction: column;
  padding: 0;
  gap: 0;
  background: var(--tg-sidebar);
  border-right: 1px solid var(--tg-border);
}

.chats-main {
  position: relative;
  display: grid;
  grid-template-rows: 56px auto minmax(0, 1fr) auto;
  overflow: hidden;
  background:
    linear-gradient(rgba(219, 231, 243, .84), rgba(219, 231, 243, .84)),
    radial-gradient(circle at 24px 24px, rgba(49, 102, 139, .075) 0 1.2px, transparent 1.4px),
    radial-gradient(circle at 76px 84px, rgba(49, 102, 139, .055) 0 1.6px, transparent 1.8px);
  background-size: auto, 68px 68px, 112px 112px;
}

body[data-theme="dark"] .chats-main {
  background:
    linear-gradient(rgba(14, 22, 33, .9), rgba(14, 22, 33, .9)),
    radial-gradient(circle at 24px 24px, rgba(255, 255, 255, .045) 0 1.2px, transparent 1.4px),
    radial-gradient(circle at 76px 84px, rgba(255, 255, 255, .035) 0 1.6px, transparent 1.8px);
  background-size: auto, 68px 68px, 112px 112px;
}

.chats-sidebar-top,
.chats-header {
  height: 56px;
  min-height: 56px;
  padding: 0 12px;
  background: var(--tg-header);
  border-bottom: 1px solid var(--tg-border);
}

.chats-brand {
  display: none !important;
}

.chats-sidebar-title {
  color: var(--tg-text);
  font-size: 19px;
  font-weight: 700;
}

.round-action,
.icon-button,
.composer-tool,
.jump-to-bottom,
.message-action-button {
  width: 40px;
  height: 40px;
  min-width: 40px;
  border: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: var(--tg-muted);
  background: transparent;
  box-shadow: none;
}

.round-action:hover,
.icon-button:hover,
.icon-button.active,
.composer-tool:hover {
  color: var(--tg-accent);
  background: rgba(42, 171, 238, .12);
}

.chats-search-wrap,
.chats-filter-row {
  background: var(--tg-sidebar);
}

.chats-search {
  height: 36px;
  border: 0;
  border-radius: 18px;
  background: var(--tg-input);
}

.chat-filter-chip {
  min-height: 30px;
  border: 0;
  border-radius: 15px;
  color: var(--tg-muted);
  background: transparent;
}

.chat-filter-chip.active {
  color: var(--tg-accent);
  background: rgba(42, 171, 238, .14);
}

.chats-list {
  flex: 1 1;
  min-height: 0;
  gap: 0;
  padding: 0;
  overflow: auto;
  background: var(--tg-sidebar);
}

.chat-row,
.chat-row-skeleton {
  position: relative;
  width: 100%;
  min-height: 72px;
  border: 0;
  border-radius: 0;
  grid-template-columns: 54px minmax(0, 1fr) auto;
  gap: 10px;
  padding: 8px 12px;
  color: var(--tg-text);
  background: transparent;
}

.chat-row::after,
.chat-row-skeleton::after {
  content: "";
  position: absolute;
  left: 76px;
  right: 0;
  bottom: 0;
  height: 1px;
  background: rgba(23, 33, 43, .08);
}

body[data-theme="dark"] .chat-row::after,
body[data-theme="dark"] .chat-row-skeleton::after {
  background: rgba(255, 255, 255, .045);
}

.chat-row:hover {
  background: rgba(42, 171, 238, .07);
}

.chat-row.active {
  background: rgba(42, 171, 238, .14);
}

.chat-avatar,
.skeleton-avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
}

.chat-row-title {
  color: var(--tg-text);
  font-size: 15px;
  font-weight: 600;
}

.chat-row-preview,
.chat-row-time {
  color: var(--tg-muted);
  font-size: 13px;
}

.chat-unread-badge {
  background: #4dcd5e;
}

.messages-panel {
  min-height: 0;
  padding: 14px max(12px, calc((100% - 920px) / 2)) 10px;
  overflow: auto;
  scroll-behavior: smooth;
}

.message-list-skeleton {
  min-height: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.messages-date-divider span {
  min-height: 26px;
  border-radius: 13px;
  padding: 0 12px;
  background: rgba(109, 127, 144, .58);
  backdrop-filter: blur(8px);
}

.message-row {
  display: flex;
  flex-direction: column;
}

.message-row.mine {
  align-items: flex-end;
}

.message-row.other {
  align-items: flex-start;
}

.message-bubble {
  max-width: min(620px, 78%);
  border: 0;
  border-radius: 11px;
  padding: 6px 8px 4px;
  color: var(--tg-text);
  box-shadow: 0 1px 2px rgba(0, 0, 0, .18);
  animation: telegram-message-in .2s cubic-bezier(.18, .9, .22, 1.12) both;
}

.message-bubble.other {
  border-bottom-left-radius: 3px;
  background: var(--tg-bubble-other);
}

.message-bubble.mine {
  border: 0;
  border-bottom-right-radius: 3px;
  background: var(--tg-bubble-mine);
}

.message-text {
  color: var(--tg-text);
  font-size: 16px;
  line-height: 1.36;
}

.composer {
  position: sticky;
  bottom: 0;
  z-index: 4;
  border: 0;
  padding: 7px max(8px, calc((100% - 940px) / 2)) 10px;
  background: linear-gradient(180deg, rgba(219, 231, 243, 0), rgba(219, 231, 243, .96) 22%);
}

body[data-theme="dark"] .composer {
  background: linear-gradient(180deg, rgba(14, 22, 33, 0), rgba(14, 22, 33, .96) 22%);
}

.composer-shell {
  width: 100%;
  max-width: none;
  border: 0;
  border-radius: 0;
  display: grid;
  grid-template-columns: 40px 40px minmax(0, 1fr) 40px 46px;
  align-items: end;
  gap: 6px;
  margin: 0;
  background: transparent;
  box-shadow: none;
}

.composer-input {
  min-height: 42px;
  max-height: 140px;
  border: 0;
  border-radius: 21px;
  resize: none;
  padding: 11px 14px;
  background: var(--tg-input);
  color: var(--tg-text);
  font-size: 15px;
}

.composer-send {
  width: 44px;
  height: 44px;
  min-width: 44px;
  border: 0;
  border-radius: 50%;
  background: var(--tg-accent);
  color: #fff;
  box-shadow: none;
}

.composer-editing,
.composer-attachments,
.emoji-panel {
  grid-column: 1 / -1;
}

.jump-to-bottom {
  position: absolute;
  right: max(16px, calc((100% - 920px) / 2));
  bottom: 74px;
  z-index: 8;
  background: var(--tg-panel);
  box-shadow: 0 4px 14px rgba(23, 33, 43, .18);
}

.chats-empty {
  border-radius: 14px;
  padding: 16px 18px;
  color: var(--tg-muted);
  background: rgba(255, 255, 255, .78);
}

.chat-sheet,
.chats-modal {
  position: fixed;
  inset: 0;
  z-index: 2000;
  display: grid;
  place-items: end center;
  padding: 0 10px calc(10px + env(safe-area-inset-bottom));
  background: rgba(0, 0, 0, .52);
  backdrop-filter: blur(14px);
}

.attachment-sheet-grid {
  width: min(430px, 100%);
  max-height: 82dvh;
  overflow: auto;
  border-radius: 18px;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px 12px;
  padding: 28px 18px 24px;
  color: #fff;
  background: rgba(33, 35, 39, .96);
}

.attachment-sheet-grid button {
  border: 0;
  display: grid;
  justify-items: center;
  gap: 8px;
  color: #fff;
  background: transparent;
}

.attachment-sheet-icon {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fff;
}

.attachment-sheet-icon.blue { background: linear-gradient(135deg, #2f80ed, #3b9bff); }
.attachment-sheet-icon.purple { background: linear-gradient(135deg, #7c3aed, #a855f7); }
.attachment-sheet-icon.orange { background: linear-gradient(135deg, #f59e0b, #fb923c); }

.attachment-sheet-cancel {
  width: min(430px, 100%);
  min-height: 54px;
  border: 0;
  border-radius: 14px;
  color: var(--tg-accent);
  background: rgba(33, 35, 39, .96);
  font-size: 16px;
}

.skeleton-avatar,
.skeleton-line,
.skeleton-date-pill,
.message-skeleton-bubble {
  position: relative;
  overflow: hidden;
  background: var(--tg-skeleton-base);
}

.skeleton-avatar::after,
.skeleton-line::after,
.skeleton-date-pill::after,
.message-skeleton-bubble::after {
  content: "";
  position: absolute;
  inset: 0;
  transform: translateX(-100%);
  background: linear-gradient(90deg, transparent, var(--tg-skeleton-peak), transparent);
  animation: skeleton-shimmer 1.25s ease-in-out infinite;
}

.message-skeleton-bubble {
  width: min(360px, 68%);
  min-height: 56px;
  border-radius: 13px;
  display: grid;
  align-content: center;
  gap: 8px;
  padding: 12px;
}

.message-skeleton-bubble.other {
  align-self: flex-start;
}

.message-skeleton-bubble.mine {
  align-self: flex-end;
  background: rgba(91, 185, 74, .16);
}

.message-skeleton-bubble.wide {
  width: min(470px, 78%);
}

@keyframes skeleton-shimmer {
  100% { transform: translateX(100%); }
}

@keyframes telegram-message-in {
  from { opacity: 0; transform: translateY(8px) scale(.985); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

@media (max-width: 760px) {
  .chats-shell {
    height: 100%;
    grid-template-columns: 1fr;
  }

  .chats-sidebar.hidden,
  .chats-main.hidden {
    display: none !important;
  }

  .chats-sidebar {
    border-right: 0;
  }

  .chats-main {
    height: 100%;
    grid-template-rows: 56px auto minmax(0, 1fr) auto;
  }

  .header-actions .optional-mobile-action {
    display: none;
  }

  .messages-panel {
    padding: 10px 8px 8px;
  }

  .message-bubble {
    max-width: 86%;
  }

  .composer {
    padding: 6px 8px calc(8px + env(safe-area-inset-bottom));
  }

  .composer-shell {
    grid-template-columns: 38px 38px minmax(0, 1fr) 38px 44px;
    align-items: center;
  }
}

.messages-panel.drag-over {
  outline: 2px dashed var(--tg-accent, #2aabee);
  outline-offset: -12px;
}

.attachment-card.media-button {
  border: 0;
  padding: 0;
  cursor: zoom-in;
}

.emoji-panel {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  max-width: 880px;
  margin: 8px auto 0;
  padding: 8px 10px;
  border: 1px solid var(--tg-border, #dfe7ef);
  border-radius: 14px;
  background: var(--tg-panel, #fff);
}

.emoji-choice {
  border: 0;
  border-radius: 999px;
  background: rgba(42, 171, 238, 0.12);
  padding: 6px 9px;
  cursor: pointer;
}

.chats-lightbox {
  position: fixed;
  inset: 0;
  z-index: 3000;
  display: grid;
  place-items: center;
  padding: 18px;
  background: rgba(14, 22, 33, 0.78);
}

.chats-lightbox-content {
  position: relative;
  max-width: min(960px, 96vw);
  max-height: 92dvh;
  display: grid;
  gap: 10px;
}

.chats-lightbox-close {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 36px;
  height: 36px;
  border: 0;
  border-radius: 50%;
  color: #ffffff;
  background: rgba(14, 22, 33, 0.72);
  cursor: pointer;
}

.chats-lightbox-image {
  max-width: 100%;
  max-height: 86dvh;
  border-radius: 12px;
  object-fit: contain;
}

.chats-lightbox-caption {
  color: #ffffff;
  text-align: center;
}

.composer-shell,
.composer-editing {
  background: var(--tg-panel);
  border: 1px solid var(--tg-border);
  box-shadow: none;
}

.composer-editing.reply {
  border-left: 3px solid var(--tg-accent);
}

.forward-list {
  max-height: min(460px, 70dvh);
  overflow: auto;
}

.forward-chat-row {
  width: 100%;
  border: 0;
  background: transparent;
  color: var(--tg-text);
  border-radius: 12px;
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.chat-avatar.small {
  width: 34px;
  height: 34px;
  font-size: 13px;
}

.chat-toast {
  position: fixed;
  left: 50%;
  bottom: 28px;
  transform: translateX(-50%);
  z-index: 2000;
  border-radius: 999px;
  padding: 10px 16px;
  color: #fff;
  background: rgba(23, 33, 43, 0.88);
}

body[data-theme="dark"] .chats-page {
  --chat-page-bg:
    radial-gradient(circle at top left, rgba(255, 255, 255, 0.08), transparent 24%),
    linear-gradient(180deg, #10263f 0%, #0d2238 38%, #09192b 100%);
  --chat-shell-surface: rgba(17, 28, 43, 0.88);
  --chat-shell-border: rgba(125, 167, 214, 0.12);
  --chat-shell-shadow: 0 24px 64px rgba(1, 8, 17, 0.48);
  --chat-text: #e6edf7;
  --chat-muted: #9eb3cc;
  --chat-strong: #f4f8fe;
  --chat-soft-surface: rgba(255, 255, 255, 0.08);
  --chat-soft-surface-2: rgba(18, 31, 48, 0.92);
  --chat-soft-hover: rgba(255, 255, 255, 0.06);
  --chat-active: rgba(255, 255, 255, 0.08);
  --chat-active-ring: inset 0 0 0 1px rgba(122, 169, 223, 0.18);
  --chat-header-bg: rgba(17, 28, 43, 0.92);
  --chat-header-border: rgba(125, 167, 214, 0.12);
  --chat-panel-bg:
    linear-gradient(rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.02)),
    radial-gradient(circle at top left, rgba(255, 255, 255, 0.04), transparent 22%);
  --chat-bubble-other: rgba(255, 255, 255, 0.08);
  --chat-bubble-mine: linear-gradient(180deg, #2b84d6, #16589f);
  --chat-composer-bg: rgba(17, 28, 43, 0.92);
  --chat-modal-bg: #111e2f;
  --chat-modal-overlay: rgba(2, 8, 16, 0.6);
}

.chats-shell {
  display: grid;
  grid-template-columns: 356px minmax(0, 1fr);
  gap: 16px;
  min-height: 100vh;
  max-width: 1360px;
  margin: 0 auto;
  padding: 14px;
  box-sizing: border-box;
}

.chats-sidebar,
.chats-main {
  min-height: 0;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.46);
  background: rgba(245, 249, 255, 0.78);
  backdrop-filter: blur(14px);
  box-shadow: 0 22px 60px rgba(15, 58, 109, 0.16);
}

.chats-sidebar {
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.chats-sidebar-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 18px 18px 10px;
}

.chats-brand {
  font-size: 12px;
  letter-spacing: 0.18em;
  font-weight: 800;
  color: rgba(18, 35, 56, 0.58);
}

.chats-sidebar-title {
  margin-top: 4px;
  font-size: 28px;
  line-height: 1;
  font-weight: 800;
  color: #0f2843;
}

.round-action,
.icon-button,
.composer-send,
.jump-to-bottom,
.sheet-primary,
.messages-loadmore {
  border: 0;
  cursor: pointer;
  transition: transform 0.18s ease, opacity 0.18s ease, background 0.18s ease;
}

.round-action,
.icon-button,
.composer-tool,
.composer-send,
.jump-to-bottom {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.round-action:hover,
.icon-button:hover,
.composer-send:hover,
.jump-to-bottom:hover,
.sheet-primary:hover,
.messages-loadmore:hover {
  transform: translateY(-1px);
}

.round-action {
  width: 44px;
  height: 44px;
  border-radius: 22px;
  font-size: 28px;
  line-height: 1;
}

.round-action.primary {
  background: linear-gradient(180deg, #2f9bff, #177ce2);
  color: #fff;
  box-shadow: 0 12px 26px rgba(21, 110, 199, 0.25);
}

.chats-search-wrap {
  padding: 10px 18px 14px;
}

.chats-input,
.composer-input {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid rgba(23, 60, 94, 0.14);
  background: rgba(255, 255, 255, 0.92);
  color: #173251;
  border-radius: 18px;
  padding: 13px 15px;
  font-size: 15px;
  outline: none;
  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;
}

.chats-input:focus,
.composer-input:focus {
  border-color: rgba(31, 136, 233, 0.6);
  box-shadow: 0 0 0 4px rgba(62, 153, 238, 0.12);
  background: #fff;
}

.chats-search {
  padding-left: 16px;
}

.chats-list {
  flex: 1 1;
  overflow: auto;
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding: 0 10px 12px;
}

.chat-row {
  display: grid;
  grid-template-columns: 52px minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 12px;
  border: 0;
  border-radius: 22px;
  background: transparent;
  color: inherit;
  text-align: left;
}

.chat-row:hover {
  background: rgba(255, 255, 255, 0.52);
}

.chat-row.active {
  background: rgba(255, 255, 255, 0.88);
  box-shadow: inset 0 0 0 1px rgba(63, 144, 224, 0.18);
}

.chat-avatar {
  width: 52px;
  height: 52px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background:
    radial-gradient(circle at 28% 22%, rgba(255, 255, 255, 0.68), transparent 34%),
    linear-gradient(160deg, #4db5ff, #1e82ea 72%);
  color: #fff;
  font-size: 18px;
  font-weight: 800;
  letter-spacing: 0.04em;
  box-shadow: 0 10px 20px rgba(29, 125, 216, 0.24);
}

.chat-avatar.large {
  width: 44px;
  height: 44px;
  font-size: 15px;
}

.chat-row-body {
  min-width: 0;
  display: grid;
  gap: 5px;
}

.chat-row-top,
.chat-row-bottom {
  display: flex;
  align-items: center;
  gap: 10px;
}

.chat-row-top {
  justify-content: space-between;
}

.chat-row-title {
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 16px;
  font-weight: 700;
  color: #0f2843;
}

.chat-row-time {
  flex: 0 0 auto;
  font-size: 12px;
  color: #6484a7;
}

.chat-row-preview {
  min-width: 0;
  flex: 1 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  color: #5b7898;
}

.chat-unread-badge {
  min-width: 22px;
  height: 22px;
  padding: 0 7px;
  border-radius: 11px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: #1d93ff;
  color: #fff;
  font-size: 12px;
  font-weight: 800;
}

.chats-main {
  position: relative;
  display: grid;
  grid-template-rows: auto minmax(0, 1fr) auto;
  overflow: hidden;
}

.chats-header {
  position: sticky;
  top: 0;
  z-index: 4;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 18px;
  background: rgba(234, 244, 255, 0.82);
  border-bottom: 1px solid rgba(25, 71, 116, 0.08);
  backdrop-filter: blur(14px);
}

.chats-header-main {
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 12px;
}

.header-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.chats-header-text {
  min-width: 0;
}

.chats-header-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 18px;
  font-weight: 800;
  color: #112943;
}

.chats-header-meta {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-top: 2px;
  font-size: 13px;
  color: #6282a4;
}

.icon-button {
  width: 38px;
  height: 38px;
  border-radius: 19px;
  background: rgba(255, 255, 255, 0.78);
  color: #1a4c7a;
  font-size: 18px;
  font-weight: 700;
}

.ui-icon {
  width: 20px;
  height: 20px;
  display: block;
  flex: 0 0 auto;
}

.visually-hidden {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}

.messages-panel {
  position: relative;
  overflow: auto;
  padding: 12px 14px 12px;
  display: flex;
  flex-direction: column;
  gap: 2px;
  background:
    linear-gradient(rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.12)),
    radial-gradient(circle at top left, rgba(255, 255, 255, 0.2), transparent 22%);
}

.messages-loadmore-wrap {
  display: flex;
  justify-content: center;
  padding: 2px 0 10px;
}

.messages-loadmore {
  padding: 9px 14px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.88);
  color: #2b6598;
  font-size: 13px;
  font-weight: 700;
  box-shadow: 0 10px 18px rgba(35, 88, 144, 0.08);
}

.messages-date-divider {
  display: flex;
  justify-content: center;
  padding: 12px 0 8px;
}

.messages-date-divider span {
  padding: 6px 12px;
  border-radius: 999px;
  background: rgba(223, 235, 248, 0.86);
  color: #53718f;
  font-size: 12px;
  font-weight: 700;
}

.message-row {
  display: flex;
  flex-direction: column;
  margin-bottom: 2px;
}

.message-row.mine {
  align-items: flex-end;
}

.message-row.other {
  align-items: flex-start;
}

.message-row.starts-group {
  margin-top: 6px;
}

.message-row.ends-group {
  margin-bottom: 10px;
}

.message-row.focused .message-bubble {
  box-shadow: 0 0 0 2px rgba(18, 121, 222, 0.24), 0 12px 24px rgba(37, 92, 146, 0.12);
}

.message-author {
  margin: 0 0 4px 12px;
  font-size: 12px;
  font-weight: 700;
  color: #4c7eb2;
}

.message-bubble {
  max-width: min(78%, 620px);
  padding: 10px 12px 8px;
  border-radius: 20px;
  box-shadow: 0 12px 24px rgba(37, 92, 146, 0.12);
}

.message-bubble.other {
  border-top-left-radius: 8px;
  background: rgba(255, 255, 255, 0.96);
  color: #173251;
}

.message-bubble.mine {
  border-top-right-radius: 8px;
  background: linear-gradient(180deg, #42a6ff, #1b86ef);
  color: #fff;
}

.message-bubble.deleted {
  background: rgba(214, 224, 236, 0.85);
  color: #60758f;
  box-shadow: none;
}

.message-text {
  font-size: 15px;
  line-height: 1.42;
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.message-text.deleted {
  font-style: italic;
}

.attachment-stack {
  display: grid;
  gap: 8px;
  margin-bottom: 6px;
}

.attachment-card {
  display: block;
  border-radius: 16px;
  overflow: hidden;
  background: rgba(255, 255, 255, 0.24);
  text-decoration: none;
  color: inherit;
}

.attachment-card.file,
.attachment-card.voice {
  padding: 10px 12px;
  background: rgba(255, 255, 255, 0.18);
}

.attachment-image,
.attachment-video {
  display: block;
  width: 100%;
  max-height: 260px;
  object-fit: cover;
  background: rgba(10, 31, 53, 0.08);
}

.attachment-audio {
  width: 100%;
  margin-top: 8px;
}

.attachment-card.voice {
  display: grid;
  grid-template-columns: 40px minmax(0, 1fr);
  align-items: center;
  gap: 10px;
}

.voice-play-button {
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: #fff;
  background: var(--tg-accent);
  cursor: pointer;
  touch-action: manipulation;
}

.voice-play-button svg {
  width: 19px;
  height: 19px;
}

.voice-play-button.playing {
  background: #128c7e;
}

.voice-loading-dot {
  width: 16px;
  height: 16px;
  border: 2px solid rgba(255, 255, 255, .45);
  border-top-color: #fff;
  border-radius: 50%;
  animation: voice-spin .75s linear infinite;
}

.voice-content {
  min-width: 0;
}

.voice-wave {
  height: 24px;
  display: flex;
  align-items: center;
  gap: 3px;
  margin-top: 7px;
}

.voice-wave span {
  width: 3px;
  border-radius: 999px;
  background: rgba(0, 0, 0, .28);
}

.voice-error {
  display: block;
  margin-top: 6px;
  font-size: 11px;
  color: #b3261e;
}

@keyframes voice-spin {
  to {
    transform: rotate(360deg);
  }
}

.attachment-file-meta {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  font-size: 12px;
}

.message-links {
  display: grid;
  gap: 4px;
  margin-top: 6px;
}

.message-link {
  color: inherit;
  font-size: 12px;
  text-decoration: underline;
  overflow-wrap: anywhere;
}

.message-meta {
  margin-top: 4px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
  font-size: 11px;
}

.message-bubble.mine .message-meta {
  color: rgba(255, 255, 255, 0.82);
}

.message-bubble.other .message-meta {
  color: #7690aa;
}

.message-bubble.deleted .message-meta {
  color: #60758f;
}

.message-status {
  font-size: 12px;
  line-height: 1;
  letter-spacing: -0.08em;
}

.message-status.read {
  color: #d9f0ff;
}

.message-edited-mark {
  opacity: 0.88;
}

.message-meta-actions {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  margin-left: 4px;
}

.message-action-button {
  width: 26px;
  height: 26px;
  border: 0;
  border-radius: 13px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.22);
  color: inherit;
  cursor: pointer;
  transition: background 0.18s ease, transform 0.18s ease, opacity 0.18s ease;
}

.message-action-button:hover {
  transform: translateY(-1px);
  background: rgba(255, 255, 255, 0.28);
}

.message-action-button.danger {
  color: #ffd2d7;
}

.composer {
  position: sticky;
  bottom: 0;
  z-index: 4;
  padding: 10px 14px calc(12px + env(safe-area-inset-bottom));
  background: linear-gradient(180deg, rgba(239, 247, 255, 0.2), rgba(236, 245, 255, 0.92));
  backdrop-filter: blur(14px);
}

.composer-shell {
  display: grid;
  grid-template-columns: auto auto minmax(0, 1fr) auto auto;
  gap: 10px;
  align-items: flex-end;
  padding: 8px;
  border-radius: 24px;
  background: rgba(255, 255, 255, 0.88);
  box-shadow: 0 18px 36px rgba(37, 88, 141, 0.16);
}

.composer-editing {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 8px;
  padding: 10px 12px;
  border-radius: 18px;
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 12px 28px rgba(37, 88, 141, 0.12);
}

.composer-editing-copy {
  min-width: 0;
  display: grid;
  gap: 2px;
}

.composer-editing-copy strong {
  font-size: 13px;
  color: #173251;
}

.composer-editing-copy span {
  font-size: 12px;
  color: #53718f;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.composer-editing-cancel {
  border: 0;
  background: transparent;
  color: #1d70c8;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.composer-input {
  min-height: 22px;
  max-height: 136px;
  resize: none;
  border: 0;
  background: transparent;
  padding: 8px 10px;
  box-shadow: none;
}

.composer-input:focus {
  box-shadow: none;
}

.composer-file-input {
  display: none;
}

.composer-tool {
  width: 40px;
  height: 40px;
  border: 0;
  border-radius: 20px;
  background: rgba(23, 92, 155, 0.08);
  color: #1d70c8;
  font-size: 16px;
  font-weight: 800;
  cursor: pointer;
}

.composer-tool.recording {
  background: rgba(214, 63, 83, 0.14);
  color: #c3384e;
}

.composer-send {
  width: 44px;
  height: 44px;
  border-radius: 22px;
  background: linear-gradient(180deg, #32a0ff, #1279de);
  color: #fff;
  font-size: 18px;
  font-weight: 800;
}

.composer-send:disabled {
  opacity: 0.45;
  cursor: default;
  transform: none;
}

.jump-to-bottom {
  position: absolute;
  right: 20px;
  bottom: calc(88px + env(safe-area-inset-bottom));
  z-index: 5;
  width: 42px;
  height: 42px;
  border-radius: 21px;
  background: rgba(255, 255, 255, 0.94);
  color: #1d70c8;
  font-size: 18px;
  font-weight: 800;
  box-shadow: 0 14px 28px rgba(33, 84, 135, 0.22);
}

.chats-empty {
  padding: 22px 18px;
  text-align: center;
  color: #53718f;
}

.chats-main-empty {
  align-self: center;
}

.chats-error {
  color: #b53948;
}

.chats-modal {
  position: fixed;
  inset: 0;
  z-index: 25;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 16px;
  background: rgba(11, 32, 56, 0.32);
  backdrop-filter: blur(6px);
}

.chats-modal-sheet {
  width: min(100%, 460px);
  border-radius: 28px;
  background: #f4f9ff;
  box-shadow: 0 28px 60px rgba(15, 47, 83, 0.28);
  padding: 10px 16px 18px;
}

.chats-modal-handle {
  width: 44px;
  height: 5px;
  border-radius: 999px;
  margin: 4px auto 10px;
  background: rgba(75, 108, 140, 0.28);
}

.chats-modal-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 12px;
}

.chats-modal-title {
  font-size: 20px;
  font-weight: 800;
  color: #0f2843;
}

.sheet-form {
  display: grid;
  gap: 10px;
}

.sheet-primary.compact {
  min-height: 44px;
  padding: 0 16px;
}

.sheet-secondary {
  min-height: 48px;
  border: 0;
  border-radius: 18px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  background: rgba(255, 255, 255, 0.88);
  color: #173251;
  font-size: 15px;
  font-weight: 700;
  cursor: pointer;
}

.sheet-secondary.danger {
  color: #c3384e;
}

.search-row {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
}

.sheet-results,
.media-list {
  display: grid;
  gap: 8px;
  max-height: 54vh;
  overflow: auto;
}

.sheet-result,
.media-list-item {
  width: 100%;
  text-align: left;
  border: 0;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.9);
  padding: 12px;
  color: inherit;
}

.sheet-result-title {
  font-size: 14px;
  font-weight: 700;
  color: #14304d;
}

.sheet-result-meta {
  margin-top: 4px;
  font-size: 12px;
  color: #6e89a3;
}

.media-tabs {
  display: flex;
  gap: 8px;
  overflow: auto;
  margin-bottom: 12px;
}

.media-tab,
.counter-chip {
  border: 0;
  border-radius: 999px;
  background: rgba(29, 112, 200, 0.1);
  color: #1d70c8;
  font-size: 13px;
  font-weight: 700;
  padding: 8px 12px;
  cursor: pointer;
}

.media-tab.active {
  background: #1d70c8;
  color: #fff;
}

.settings-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 12px;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.85);
  color: #173251;
  font-size: 14px;
}

.settings-row input[type="checkbox"] {
  accent-color: #1d70c8;
}

.settings-counters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.sheet-primary {
  min-height: 48px;
  border-radius: 18px;
  background: linear-gradient(180deg, #2fa0ff, #197fe6);
  color: #fff;
  font-size: 15px;
  font-weight: 800;
}

.sheet-primary:disabled {
  opacity: 0.55;
  cursor: default;
  transform: none;
}

.hidden {
  display: none;
}

body[data-theme="dark"] .chats-sidebar,
body[data-theme="dark"] .chats-main {
  border-color: rgba(125, 167, 214, 0.12);
  background: rgba(17, 28, 43, 0.88);
  box-shadow: 0 24px 64px rgba(1, 8, 17, 0.48);
}

body[data-theme="dark"] .chats-brand,
body[data-theme="dark"] .chat-row-time,
body[data-theme="dark"] .chat-row-preview,
body[data-theme="dark"] .chats-header-meta,
body[data-theme="dark"] .chats-empty,
body[data-theme="dark"] .sheet-result-meta {
  color: #9eb3cc;
}

body[data-theme="dark"] .chats-sidebar-title,
body[data-theme="dark"] .chat-row-title,
body[data-theme="dark"] .chats-header-name,
body[data-theme="dark"] .chats-modal-title,
body[data-theme="dark"] .sheet-result-title,
body[data-theme="dark"] .settings-row,
body[data-theme="dark"] .media-list-item {
  color: #f4f8fe;
}

body[data-theme="dark"] .chat-row:hover {
  background: rgba(255, 255, 255, 0.06);
}

body[data-theme="dark"] .chat-row.active {
  background: rgba(255, 255, 255, 0.08);
  box-shadow: inset 0 0 0 1px rgba(122, 169, 223, 0.18);
}

body[data-theme="dark"] .chats-input,
body[data-theme="dark"] .composer-shell,
body[data-theme="dark"] .sheet-result,
body[data-theme="dark"] .media-list-item,
body[data-theme="dark"] .settings-row,
body[data-theme="dark"] .messages-loadmore,
body[data-theme="dark"] .icon-button,
body[data-theme="dark"] .composer-tool,
body[data-theme="dark"] .jump-to-bottom,
body[data-theme="dark"] .counter-chip,
body[data-theme="dark"] .media-tab {
  background: rgba(255, 255, 255, 0.08);
  color: #e6edf7;
  border-color: rgba(125, 167, 214, 0.12);
}

body[data-theme="dark"] .chats-input,
body[data-theme="dark"] .composer-input {
  color: #e6edf7;
  border-color: rgba(125, 167, 214, 0.14);
}

body[data-theme="dark"] .chats-header {
  background: rgba(17, 28, 43, 0.92);
  border-bottom-color: rgba(125, 167, 214, 0.12);
}

body[data-theme="dark"] .messages-panel {
  background:
    linear-gradient(rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.02)),
    radial-gradient(circle at top left, rgba(255, 255, 255, 0.04), transparent 22%);
}

body[data-theme="dark"] .message-bubble.other {
  background: rgba(255, 255, 255, 0.08);
  color: #e6edf7;
}

body[data-theme="dark"] .message-bubble.deleted {
  background: rgba(255, 255, 255, 0.08);
  color: #9eb3cc;
}

body[data-theme="dark"] .message-bubble.mine {
  background: linear-gradient(180deg, #2b84d6, #16589f);
}

body[data-theme="dark"] .message-bubble.other .message-meta,
body[data-theme="dark"] .message-author,
body[data-theme="dark"] .messages-date-divider span {
  color: #9eb3cc;
}

body[data-theme="dark"] .message-bubble.deleted .message-meta {
  color: #9eb3cc;
}

body[data-theme="dark"] .messages-date-divider span {
  background: rgba(255, 255, 255, 0.08);
}

body[data-theme="dark"] .composer {
  background: linear-gradient(180deg, rgba(17, 28, 43, 0.25), rgba(17, 28, 43, 0.96));
}

body[data-theme="dark"] .chats-modal {
  background: rgba(2, 8, 16, 0.6);
}

body[data-theme="dark"] .chats-modal-sheet {
  background: #111e2f;
}

body[data-theme="dark"] .attachment-card,
body[data-theme="dark"] .attachment-card.file,
body[data-theme="dark"] .attachment-card.voice {
  background: rgba(255, 255, 255, 0.08);
}

body[data-theme="dark"] .message-action-button,
body[data-theme="dark"] .sheet-secondary,
body[data-theme="dark"] .composer-editing {
  background: rgba(255, 255, 255, 0.08);
  color: #e6edf7;
}

body[data-theme="dark"] .composer-editing-copy strong {
  color: #f4f8fe;
}

body[data-theme="dark"] .composer-editing-copy span {
  color: #9eb3cc;
}

body[data-theme="dark"] .composer-editing-cancel {
  color: #8dc8ff;
}

body[data-theme="dark"] .message-action-button.danger,
body[data-theme="dark"] .sheet-secondary.danger {
  color: #ffb5bf;
}

body[data-theme="dark"] .attachment-image,
body[data-theme="dark"] .attachment-video {
  background: rgba(255, 255, 255, 0.06);
}

body[data-theme="dark"] .message-status.read {
  color: #8dd7ff;
}

@media (max-width: 980px) {
  .chats-shell {
    grid-template-columns: 320px minmax(0, 1fr);
    padding: 10px;
  }

  .message-bubble {
    max-width: 88%;
  }
}

@media (max-width: 767px) {
  .chats-page {
    background: var(--chat-page-bg);
  }

  .chats-shell {
    display: block;
    padding: 0;
  }

  .chats-sidebar,
  .chats-main {
    min-height: 100vh;
    border-radius: 0;
    border: 0;
    box-shadow: none;
  }

  .chats-sidebar-top {
    padding-top: calc(16px + env(safe-area-inset-top));
  }

  .chats-header {
    padding-top: calc(12px + env(safe-area-inset-top));
  }

  .messages-panel {
    padding-left: 10px;
    padding-right: 10px;
  }

  .message-bubble {
    max-width: 92%;
  }

  .jump-to-bottom {
    right: 14px;
    bottom: calc(84px + env(safe-area-inset-bottom));
  }

  .chats-modal {
    padding: 0;
    align-items: flex-end;
  }

  .chats-modal-sheet {
    width: 100%;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    padding-bottom: calc(18px + env(safe-area-inset-bottom));
  }
}

/* Final Telegram-like overrides */
.chats-page {
  background: var(--tg-bg, #e7eef5);
  color: var(--tg-text, #17212b);
}

.chats-shell {
  grid-template-columns: minmax(300px, 368px) minmax(0, 1fr);
  gap: 0;
  max-width: none;
  min-height: 100dvh;
  padding: 0;
}

.chats-sidebar,
.chats-main {
  border: 0;
  border-radius: 0;
  box-shadow: none;
  backdrop-filter: none;
}

.chats-sidebar {
  background: var(--tg-sidebar, #fff);
  border-right: 1px solid var(--tg-border, #dfe7ef);
}

.chats-main {
  background:
    linear-gradient(rgba(231, 238, 245, 0.84), rgba(231, 238, 245, 0.84)),
    repeating-linear-gradient(45deg, rgba(42, 171, 238, 0.04) 0 1px, transparent 1px 18px);
}

.chat-row {
  border-radius: 0;
  border: 0;
}

.message-bubble.other {
  background: var(--tg-bubble-other, #fff);
}

.message-bubble.mine {
  background: var(--tg-bubble-mine, #effdde);
  color: var(--tg-text, #17212b);
}

.composer {
  background: transparent;
}

/* EOF override: keep ordinary support /chats in native messenger mode. */
.pageContentInner:has(> .chats-page) {
  padding: 0 !important;
}

.chats-page {
  --tg-bg: #dbe7f3;
  --tg-sidebar: #fff;
  --tg-panel: #fff;
  --tg-header: #fff;
  --tg-border: #d3dde8;
  --tg-text: #17212b;
  --tg-muted: #6d7f90;
  --tg-accent: #2aabee;
  --tg-bubble-other: #fff;
  --tg-bubble-mine: #dff7c7;
  --tg-input: #fff;
  --tg-skeleton-base: rgba(23, 33, 43, .08);
  --tg-skeleton-peak: rgba(255, 255, 255, .72);
  height: calc(var(--vh, 1vh) * 100) !important;
  min-height: 0 !important;
  overflow: hidden !important;
  background: var(--tg-bg) !important;
  color: var(--tg-text) !important;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial, sans-serif !important;
}

body[data-theme="dark"] .chats-page {
  --tg-bg: #0e1621;
  --tg-sidebar: #17212b;
  --tg-panel: #17212b;
  --tg-header: #17212b;
  --tg-border: #0b1118;
  --tg-text: #eef6fc;
  --tg-muted: #7f91a4;
  --tg-bubble-other: #182533;
  --tg-bubble-mine: #2b5278;
  --tg-input: #242f3d;
  --tg-skeleton-base: rgba(255, 255, 255, .07);
  --tg-skeleton-peak: rgba(255, 255, 255, .16);
}

.chats-shell {
  width: 100% !important;
  height: 100% !important;
  min-height: 0 !important;
  max-width: none !important;
  display: grid !important;
  grid-template-columns: 360px minmax(0, 1fr) !important;
  gap: 0 !important;
  margin: 0 !important;
  padding: 0 !important;
  overflow: hidden !important;
}

.chats-sidebar,
.chats-main {
  min-height: 0 !important;
  border: 0 !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  backdrop-filter: none !important;
}

.chats-sidebar {
  display: flex !important;
  flex-direction: column !important;
  padding: 0 !important;
  overflow: hidden !important;
  background: var(--tg-sidebar) !important;
  border-right: 1px solid var(--tg-border) !important;
}

.chats-main {
  position: relative !important;
  display: grid !important;
  grid-template-rows: 56px auto minmax(0, 1fr) auto !important;
  overflow: hidden !important;
  background:
    linear-gradient(rgba(219, 231, 243, .84), rgba(219, 231, 243, .84)),
    radial-gradient(circle at 24px 24px, rgba(49, 102, 139, .075) 0 1.2px, transparent 1.4px),
    radial-gradient(circle at 76px 84px, rgba(49, 102, 139, .055) 0 1.6px, transparent 1.8px) !important;
  background-size: auto, 68px 68px, 112px 112px !important;
}

body[data-theme="dark"] .chats-main {
  background:
    linear-gradient(rgba(14, 22, 33, .9), rgba(14, 22, 33, .9)),
    radial-gradient(circle at 24px 24px, rgba(255, 255, 255, .045) 0 1.2px, transparent 1.4px),
    radial-gradient(circle at 76px 84px, rgba(255, 255, 255, .035) 0 1.6px, transparent 1.8px) !important;
}

.chats-sidebar-top,
.chats-header {
  height: 56px !important;
  min-height: 56px !important;
  padding: 0 12px !important;
  background: var(--tg-header) !important;
  border-bottom: 1px solid var(--tg-border) !important;
}

.chats-brand {
  display: none !important;
}

.chats-sidebar-title {
  color: var(--tg-text) !important;
  font-size: 19px !important;
  font-weight: 700 !important;
}

.round-action,
.icon-button,
.composer-tool,
.jump-to-bottom,
.message-action-button {
  width: 40px !important;
  height: 40px !important;
  min-width: 40px !important;
  border: 0 !important;
  border-radius: 50% !important;
  color: var(--tg-muted) !important;
  background: transparent !important;
  box-shadow: none !important;
}

.round-action:hover,
.icon-button:hover,
.icon-button.active,
.composer-tool:hover {
  color: var(--tg-accent) !important;
  background: rgba(42, 171, 238, .12) !important;
}

.chats-search-wrap,
.chats-filter-row,
.chats-list {
  background: var(--tg-sidebar) !important;
}

.chats-search {
  height: 36px !important;
  border: 0 !important;
  border-radius: 18px !important;
  background: var(--tg-input) !important;
}

.chat-filter-chip {
  min-height: 30px !important;
  border: 0 !important;
  border-radius: 15px !important;
  color: var(--tg-muted) !important;
  background: transparent !important;
}

.chat-filter-chip.active {
  color: var(--tg-accent) !important;
  background: rgba(42, 171, 238, .14) !important;
}

.chats-list {
  flex: 1 1 !important;
  min-height: 0 !important;
  gap: 0 !important;
  padding: 0 !important;
  overflow: auto !important;
}

.chat-row,
.chat-row-skeleton {
  position: relative !important;
  width: 100% !important;
  min-height: 72px !important;
  border: 0 !important;
  border-radius: 0 !important;
  grid-template-columns: 54px minmax(0, 1fr) auto !important;
  gap: 10px !important;
  padding: 8px 12px !important;
  color: var(--tg-text) !important;
  background: transparent !important;
}

.chat-row::after,
.chat-row-skeleton::after {
  content: "" !important;
  position: absolute !important;
  left: 76px !important;
  right: 0 !important;
  bottom: 0 !important;
  height: 1px !important;
  background: rgba(23, 33, 43, .08) !important;
}

.chat-row:hover {
  background: rgba(42, 171, 238, .07) !important;
}

.chat-row.active {
  background: rgba(42, 171, 238, .14) !important;
}

.chat-avatar,
.skeleton-avatar {
  width: 50px !important;
  height: 50px !important;
  border-radius: 50% !important;
}

.chat-row-title {
  color: var(--tg-text) !important;
  font-size: 15px !important;
  font-weight: 600 !important;
}

.chat-row-preview,
.chat-row-time {
  color: var(--tg-muted) !important;
  font-size: 13px !important;
}

.messages-panel {
  min-height: 0 !important;
  padding: 14px max(12px, calc((100% - 920px) / 2)) 10px !important;
  overflow: auto !important;
  scroll-behavior: smooth !important;
}

.messages-date-divider span {
  min-height: 26px !important;
  border-radius: 13px !important;
  padding: 0 12px !important;
  background: rgba(109, 127, 144, .58) !important;
  backdrop-filter: blur(8px) !important;
}

.message-row.mine {
  align-items: flex-end !important;
}

.message-row.other {
  align-items: flex-start !important;
}

.message-bubble {
  max-width: min(620px, 78%) !important;
  border: 0 !important;
  border-radius: 11px !important;
  padding: 6px 8px 4px !important;
  color: var(--tg-text) !important;
  box-shadow: 0 1px 2px rgba(0, 0, 0, .18) !important;
  animation: telegram-message-in .2s cubic-bezier(.18, .9, .22, 1.12) both !important;
}

.message-bubble.other {
  border-bottom-left-radius: 3px !important;
  background: var(--tg-bubble-other) !important;
}

.message-bubble.mine {
  border-bottom-right-radius: 3px !important;
  background: var(--tg-bubble-mine) !important;
}

.message-text {
  color: var(--tg-text) !important;
  font-size: 16px !important;
  line-height: 1.36 !important;
}

.composer {
  position: sticky !important;
  bottom: 0 !important;
  z-index: 4 !important;
  border: 0 !important;
  padding: 7px max(8px, calc((100% - 940px) / 2)) 10px !important;
  background: linear-gradient(180deg, rgba(219, 231, 243, 0), rgba(219, 231, 243, .96) 22%) !important;
}

.composer-shell {
  width: 100% !important;
  max-width: none !important;
  border: 0 !important;
  border-radius: 0 !important;
  display: grid !important;
  grid-template-columns: 40px 40px minmax(0, 1fr) 40px 46px !important;
  align-items: end !important;
  gap: 6px !important;
  margin: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}

.composer-input {
  min-height: 42px !important;
  max-height: 140px !important;
  border: 0 !important;
  border-radius: 21px !important;
  resize: none !important;
  padding: 11px 14px !important;
  background: var(--tg-input) !important;
  color: var(--tg-text) !important;
  font-size: 15px !important;
}

.composer-send {
  width: 44px !important;
  height: 44px !important;
  min-width: 44px !important;
  border: 0 !important;
  border-radius: 50% !important;
  background: var(--tg-accent) !important;
  color: #fff !important;
  box-shadow: none !important;
}

.composer-editing,
.composer-attachments,
.emoji-panel {
  grid-column: 1 / -1 !important;
}

.jump-to-bottom {
  position: absolute !important;
  right: max(16px, calc((100% - 920px) / 2)) !important;
  bottom: 74px !important;
  z-index: 8 !important;
  background: var(--tg-panel) !important;
  box-shadow: 0 4px 14px rgba(23, 33, 43, .18) !important;
}

.chats-empty {
  border-radius: 14px !important;
  padding: 16px 18px !important;
  color: var(--tg-muted) !important;
  background: rgba(255, 255, 255, .78) !important;
}

.settings-status {
  color: var(--tg-muted);
  font-size: 13px;
  padding: 0 4px;
}

.settings-mute-options,
.settings-counters {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.chat-sheet,
.chats-modal {
  position: fixed !important;
  inset: 0 !important;
  z-index: 2000 !important;
  display: grid !important;
  place-items: end center !important;
  padding: 0 10px calc(10px + env(safe-area-inset-bottom)) !important;
  background: rgba(0, 0, 0, .52) !important;
  backdrop-filter: blur(14px) !important;
}

.attachment-sheet-grid {
  width: min(430px, 100%) !important;
  max-height: 82dvh !important;
  overflow: auto !important;
  border-radius: 18px !important;
  display: grid !important;
  grid-template-columns: repeat(3, 1fr) !important;
  gap: 20px 12px !important;
  padding: 28px 18px 24px !important;
  color: #fff !important;
  background: rgba(33, 35, 39, .96) !important;
}

.attachment-sheet-grid button {
  border: 0 !important;
  display: grid !important;
  justify-items: center !important;
  gap: 8px !important;
  color: #fff !important;
  background: transparent !important;
}

.attachment-sheet-icon {
  width: 52px !important;
  height: 52px !important;
  border-radius: 50% !important;
  display: inline-flex !important;
  align-items: center !important;
  justify-content: center !important;
  color: #fff !important;
}

.attachment-sheet-icon.blue { background: linear-gradient(135deg, #2f80ed, #3b9bff) !important; }
.attachment-sheet-icon.purple { background: linear-gradient(135deg, #7c3aed, #a855f7) !important; }
.attachment-sheet-icon.orange { background: linear-gradient(135deg, #f59e0b, #fb923c) !important; }

.attachment-sheet-cancel {
  width: min(430px, 100%) !important;
  min-height: 54px !important;
  border: 0 !important;
  border-radius: 14px !important;
  color: var(--tg-accent) !important;
  background: rgba(33, 35, 39, .96) !important;
  font-size: 16px !important;
}

.skeleton-avatar,
.skeleton-line,
.skeleton-date-pill,
.message-skeleton-bubble {
  position: relative !important;
  overflow: hidden !important;
  background: var(--tg-skeleton-base) !important;
}

.skeleton-avatar::after,
.skeleton-line::after,
.skeleton-date-pill::after,
.message-skeleton-bubble::after {
  content: "" !important;
  position: absolute !important;
  inset: 0 !important;
  transform: translateX(-100%) !important;
  background: linear-gradient(90deg, transparent, var(--tg-skeleton-peak), transparent) !important;
  animation: skeleton-shimmer 1.25s ease-in-out infinite !important;
}

.message-skeleton-bubble {
  width: min(360px, 68%) !important;
  min-height: 56px !important;
  border-radius: 13px !important;
  display: grid !important;
  align-content: center !important;
  gap: 8px !important;
  padding: 12px !important;
}

.message-skeleton-bubble.other {
  align-self: flex-start !important;
}

.message-skeleton-bubble.mine {
  align-self: flex-end !important;
  background: rgba(91, 185, 74, .16) !important;
}

.message-skeleton-bubble.wide {
  width: min(470px, 78%) !important;
}

@media (max-width: 760px) {
  .chats-shell {
    height: 100% !important;
    grid-template-columns: 1fr !important;
  }

  .chats-sidebar.hidden,
  .chats-main.hidden {
    display: none !important;
  }

  .chats-sidebar {
    border-right: 0 !important;
  }

  .chats-main {
    height: 100% !important;
    grid-template-rows: 56px auto minmax(0, 1fr) auto !important;
  }

  .header-actions .optional-mobile-action {
    display: none !important;
  }

  .messages-panel {
    padding: 10px 8px 8px !important;
  }

  .message-bubble {
    max-width: 86% !important;
  }

  .composer {
    padding: 6px 8px calc(8px + env(safe-area-inset-bottom)) !important;
  }

  .composer-shell {
    grid-template-columns: 38px 38px minmax(0, 1fr) 38px 44px !important;
    align-items: center !important;
  }
}

.chat-screen-grid{display:flex;gap:8px;max-height:45vh;flex-shrink:0;overflow:auto;background:#142035;padding:8px}.chat-shared-screen{margin:0;flex:1 1;min-width:220px;color:white}.chat-shared-screen video{width:100%;max-height:36vh;background:#000;object-fit:contain}.chat-shared-screen figcaption{padding:4px;font-size:12px}
`, "",{"version":3,"sources":["webpack://./src/Pages/ChatsPage/ChatsPage.css"],"names":[],"mappings":"AAAA;EACE;;kEAEgE;EAChE,+CAA+C;EAC/C,8CAA8C;EAC9C,wDAAwD;EACxD,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,8CAA8C;EAC9C,gDAAgD;EAChD,4CAA4C;EAC5C,wCAAwC;EACxC,4DAA4D;EAC5D,2CAA2C;EAC3C,6CAA6C;EAC7C;;kFAEgF;EAChF,8CAA8C;EAC9C,6DAA6D;EAC7D,6CAA6C;EAC7C,wBAAwB;EACxB,4CAA4C;EAC5C,iBAAiB;EACjB,+BAA+B;EAC/B,uBAAuB;EACvB,8CAA8C;AAChD;;AAEA,yCAAyC;AACzC;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,sCAAsC;EACtC,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,0BAA0B;EAC1B,yBAAyB;EACzB,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,mCAAmC;EACnC,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,0DAA0D;EAC1D,MAAM;EACN,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE;;0FAEwF;AAC1F;;AAEA;EACE;;4FAE0F;AAC5F;;AAEA;;;EAGE,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,kCAAkC;EAClC,oBAAoB;EACpB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,oBAAoB;EACpB,QAAQ;AACV;;AAEA;EACE,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;;EAEE,oBAAoB;EACpB,WAAW;EACX,YAAY;EACZ,uBAAuB;AACzB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,eAAe;EACf,aAAa;EACb,qBAAqB;EACrB,aAAa;EACb,0CAA0C;EAC1C,QAAQ;EACR,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;;EAEE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,iCAAiC;EACjC,qBAAqB;AACvB;;AAEA;;;EAGE,uCAAuC;EACvC,oCAAoC;EACpC,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;;EAEE,SAAS;EACT,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,YAAY;AACd;;AAEA;EACE,uBAAuB;AACzB;;AAEA,iGAAiG;AACjG;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;EACzC,4CAA4C;EAC5C,sBAAsB;EACtB,6CAA6C;EAC7C,wBAAwB;EACxB,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,gGAAgG;AAClG;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,wBAAwB;EACxB,sDAAsD;EACtD,iBAAiB;EACjB,0BAA0B;EAC1B,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,qBAAqB;EACrB,iBAAiB;EACjB,2BAA2B;EAC3B,wCAAwC;EACxC,mDAAmD;AACrD;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,4DAA4D;EAC5D,2BAA2B;EAC3B;;;wGAGsG;EACtG,wDAAwD;AAC1D;;AAEA;EACE;;;yGAGuG;AACzG;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,uCAAuC;EACvC,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;;;;EAKE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;EACpB,6BAA6B;EAC7B,iCAAiC;EACjC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;;;EAIE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;;EAEE,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,8BAA8B;EAC9B,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,oBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;EACzB,wCAAwC;AAC1C;;AAEA;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,0DAA0D;EAC1D,oBAAoB;EACpB,4BAA4B;EAC5B,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;;EAEE,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,iEAAiE;EACjE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,mDAAmD;EACnD,mFAAmF;AACrF;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,+DAA+D;EAC/D,oGAAoG;AACtG;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;EACpB,2BAA2B;EAC3B,wBAAwB;EACxB,oEAAoE;EACpE,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAoB;EACpB,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,sCAAsC;EACtC,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;EACpB,6BAA6B;EAC7B,uCAAuC;EACvC,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,qDAAqD;EACrD,uBAAuB;EACvB,qBAAqB;EACrB,sCAAsC;EACtC,uDAAuD;AACzD;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,wBAAwB;EACxB,wBAAwB;EACxB,kCAAkC;EAClC,mEAAmE;EACnE,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,yBAAyB;EACzB,8BAA8B;EAC9B,wBAAwB;EACxB,gDAAgD;EAChD,yBAAyB;EACzB,kCAAkC;EAClC,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,gCAAgC;EAChC,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA,8BAA8B,gEAAgE,EAAE;AAChG,gCAAgC,gEAAgE,EAAE;AAClG,gCAAgC,gEAAgE,EAAE;;AAElG;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,oBAAoB;EACpB,8BAA8B;EAC9B,kCAAkC;EAClC,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;;;;EAIE,6BAA6B;EAC7B,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;;;;EAIE,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,uCAAuC;EACvC,gGAAgG;EAChG,iEAAiE;AACnE;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,8BAA8B;EAC9B,wBAAwB;EACxB,gCAAgC;EAChC,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,uBAAuB;IACvB,qCAAqC;EACvC;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,4DAA4D;EAC9D;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mEAAmE;EACrE;;EAEA;IACE,oEAAoE;IACpE,8BAA8B;EAChC;AACF;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,+CAA+C;EAC/C,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;EACxB,wBAAwB;EACxB,0DAA0D;EAC1D,8BAA8B;EAC9B,oBAAoB;EACpB,qDAAqD;EACrD,8BAA8B;EAC9B,gDAAgD;EAChD,wDAAwD;EACxD,sBAAsB;AACxB;;AAEA;EACE,gDAAgD;EAChD,6DAA6D;AAC/D;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,gDAAgD;AAClD;;AAEA;EACE,gDAAgD;EAChD,6DAA6D;AAC/D;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,8BAA8B;EAC9B,wBAAwB;EACxB,8BAA8B;EAC9B,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;;EAEE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;EAC9B,0BAA0B;EAC1B,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,kCAAkC;EAClC,8BAA8B;EAC9B,0BAA0B;EAC1B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,oBAAoB;EACpB,8BAA8B;EAC9B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,mBAAmB;EACnB,0BAA0B;EAC1B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;AAC5B;;AAEA;EACE,6BAA6B;EAC7B,qBAAqB;EACrB,oBAAoB;EACpB,kCAAkC;EAClC,yBAAyB;EACzB,0BAA0B;EAC1B,2BAA2B;EAC3B,2BAA2B;EAC3B,0BAA0B;AAC5B;;AAEA;EACE;IACE,4BAA4B;IAC5B,qDAAqD;EACvD;;EAEA;IACE,8BAA8B;IAC9B,mCAAmC;EACrC;;EAEA;IACE,oBAAsB;EACxB;AACF;;AAEA,wDAAwD;AACxD;EACE,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;EACzB,gCAAgC;EAChC,gBAAgB;EAChB,yCAAyC;EACzC,4CAA4C;EAC5C,WAAW;EACX,kCAAkC;EAClC,aAAa;EACb,gBAAgB;EAChB,wBAAwB;EACxB,qBAAqB;EACrB,qFAAqF;AACvF;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,gCAAgC;EAChC,mBAAmB;EACnB,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,aAAa;EACb,2CAA2C;EAC3C,MAAM;EACN,UAAU;EACV,SAAS;EACT,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,MAAM;EACN,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,iDAAiD;EACjD,gBAAgB;EAChB;;;6FAG2F;EAC3F,6CAA6C;AAC/C;;AAEA;EACE;;;8FAG4F;EAC5F,6CAA6C;AAC/C;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,4BAA4B;EAC5B,yCAAyC;AAC3C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;;;;EAKE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;;;;EAIE,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;;EAEE,6BAA6B;AAC/B;;AAEA;EACE,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,MAAM;EACN,UAAU;EACV,cAAc;EACd,6BAA6B;AAC/B;;AAEA;;EAEE,kBAAkB;EAClB,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,gBAAgB;EAChB,+CAA+C;EAC/C,SAAS;EACT,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,SAAS;EACT,WAAW;EACX,iCAAiC;AACnC;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sDAAsD;EACtD,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,oCAAoC;EACpC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,0BAA0B;EAC1B,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,qBAAqB;EACrB,wCAAwC;EACxC,wEAAwE;AAC1E;;AAEA;EACE,8BAA8B;EAC9B,kCAAkC;AACpC;;AAEA;EACE,SAAS;EACT,+BAA+B;EAC/B,iCAAiC;AACnC;;AAEA;EACE,qBAAqB;EACrB,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,SAAS;EACT,oDAAoD;EACpD,yFAAyF;AAC3F;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,WAAW;EACX,eAAe;EACf,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,yDAAyD;EACzD,gBAAgB;EAChB,QAAQ;EACR,SAAS;EACT,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,SAAS;EACT,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,2BAA2B;EAC3B,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,SAAS;EACT,kBAAkB;EAClB,4BAA4B;EAC5B,WAAW;EACX,gBAAgB;AAClB;;AAEA;;;EAGE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,0CAA0C;EAC1C,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;;EAEE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,wDAAwD;EACxD,8BAA8B;EAC9B,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,cAAc;EACd,mBAAmB;EACnB,aAAa;EACb,qCAAqC;EACrC,cAAc;EACd,uBAAuB;EACvB,WAAW;EACX,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,WAAW;EACX,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;AACb;;AAEA,8BAA8B,qDAAqD,EAAE;AACrF,gCAAgC,qDAAqD,EAAE;AACvF,gCAAgC,qDAAqD,EAAE;;AAEvF;EACE,uBAAuB;EACvB,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;AACjB;;AAEA;;;;EAIE,kBAAkB;EAClB,gBAAgB;EAChB,mCAAmC;AACrC;;AAEA;;;;EAIE,WAAW;EACX,kBAAkB;EAClB,QAAQ;EACR,4BAA4B;EAC5B,qFAAqF;EACrF,sDAAsD;AACxD;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,qBAAqB;EACrB,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,OAAO,2BAA2B,EAAE;AACtC;;AAEA;EACE,OAAO,UAAU,EAAE,sCAAsC,EAAE;EAC3D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA;EACE;IACE,YAAY;IACZ,0BAA0B;EAC5B;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,YAAY;IACZ,iDAAiD;EACnD;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,qBAAqB;EACvB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,wDAAwD;EAC1D;;EAEA;IACE,yDAAyD;IACzD,mBAAmB;EACrB;AACF;;AAEA;EACE,6CAA6C;EAC7C,qBAAqB;AACvB;;AAEA;EACE,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,2CAA2C;EAC3C,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,SAAS;EACT,oBAAoB;EACpB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kCAAkC;AACpC;;AAEA;EACE,kBAAkB;EAClB,2BAA2B;EAC3B,iBAAiB;EACjB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,cAAc;EACd,kCAAkC;EAClC,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;;EAEE,2BAA2B;EAC3B,kCAAkC;EAClC,gBAAgB;AAClB;;AAEA;EACE,uCAAuC;AACzC;;AAEA;EACE,6BAA6B;EAC7B,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,SAAS;EACT,uBAAuB;EACvB,qBAAqB;EACrB,mBAAmB;EACnB,aAAa;EACb,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,aAAa;EACb,oBAAoB;EACpB,kBAAkB;EAClB,WAAW;EACX,kCAAkC;AACpC;;AAEA;EACE;;kEAEgE;EAChE,4CAA4C;EAC5C,8CAA8C;EAC9C,qDAAqD;EACrD,oBAAoB;EACpB,qBAAqB;EACrB,sBAAsB;EACtB,8CAA8C;EAC9C,6CAA6C;EAC7C,4CAA4C;EAC5C,wCAAwC;EACxC,6DAA6D;EAC7D,wCAAwC;EACxC,+CAA+C;EAC/C;;mFAEiF;EACjF,8CAA8C;EAC9C,6DAA6D;EAC7D,0CAA0C;EAC1C,wBAAwB;EACxB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,2CAA2C;EAC3C,SAAS;EACT,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;EAME,SAAS;EACT,eAAe;EACf,2EAA2E;AAC7E;;AAEA;;;;;EAKE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;;;;;;EAME,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,qDAAqD;EACrD,WAAW;EACX,gDAAgD;AAClD;;AAEA;EACE,uBAAuB;AACzB;;AAEA;;EAEE,WAAW;EACX,sBAAsB;EACtB,wCAAwC;EACxC,qCAAqC;EACrC,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,aAAa;EACb,iFAAiF;AACnF;;AAEA;;EAEE,qCAAqC;EACrC,8CAA8C;EAC9C,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAO;EACP,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,oDAAoD;AACtD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB;;iDAE+C;EAC/C,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,gDAAgD;AAClD;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;;EAEE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,SAAO;EACP,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,4CAA4C;EAC5C,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,qCAAqC;EACrC,gDAAgD;EAChD,2BAA2B;AAC7B;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR;;kFAEgF;AAClF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,sBAAsB;EACtB,mBAAmB;EACnB,+CAA+C;AACjD;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,4BAA4B;EAC5B,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qCAAqC;EACrC,qBAAqB;EACrB,cAAc;AAChB;;AAEA;;EAEE,kBAAkB;EAClB,qCAAqC;AACvC;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,kBAAkB;EAClB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,WAAW;EACX,4BAA4B;EAC5B,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,0CAA0C;AAC5C;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,oBAAoB;EACpB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,0BAA0B;EAC1B,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,2BAA2B;EAC3B,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,2DAA2D;EAC3D,wFAAwF;EACxF,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,yDAAyD;EACzD,SAAS;EACT,qBAAqB;EACrB,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,+CAA+C;AACjD;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,YAAY;EACZ,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,SAAS;EACT,mBAAmB;EACnB,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mCAAmC;EACnC,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,gDAAgD;EAChD,UAAU;EACV,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,+CAA+C;AACjD;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,aAAa;EACb,kCAAkC;EAClC,0BAA0B;AAC5B;;AAEA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,8CAA8C;EAC9C,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,oBAAoB;EACpB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,0CAA0C;EAC1C,SAAS;AACX;;AAEA;;EAEE,aAAa;EACb,QAAQ;EACR,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,SAAS;EACT,mBAAmB;EACnB,oCAAoC;EACpC,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,cAAc;EACd,mBAAmB;AACrB;;AAEA;;EAEE,SAAS;EACT,oBAAoB;EACpB,mCAAmC;EACnC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,qCAAqC;EACrC,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,uCAAuC;EACvC,kCAAkC;EAClC,4CAA4C;AAC9C;;AAEA;;;;;;EAME,cAAc;AAChB;;AAEA;;;;;;;EAOE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qCAAqC;EACrC,qDAAqD;AACvD;;AAEA;;;;;;;;;;;EAWE,qCAAqC;EACrC,cAAc;EACd,uCAAuC;AACzC;;AAEA;;EAEE,cAAc;EACd,uCAAuC;AACzC;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE;;mFAEiF;AACnF;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;;EAGE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,mFAAmF;AACrF;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;EAGE,qCAAqC;AACvC;;AAEA;;;EAGE,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,cAAc;AAChB;;AAEA;;EAEE,qCAAqC;AACvC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,2CAA2C;IAC3C,aAAa;EACf;;EAEA;IACE,cAAc;EAChB;AACF;;AAEA;EACE;IACE,+BAA+B;EACjC;;EAEA;IACE,cAAc;IACd,UAAU;EACZ;;EAEA;;IAEE,iBAAiB;IACjB,gBAAgB;IAChB,SAAS;IACT,gBAAgB;EAClB;;EAEA;IACE,kDAAkD;EACpD;;EAEA;IACE,kDAAkD;EACpD;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,gDAAgD;EAClD;;EAEA;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,WAAW;IACX,4BAA4B;IAC5B,6BAA6B;IAC7B,wDAAwD;EAC1D;AACF;;AAEA,kCAAkC;AAClC;EACE,iCAAiC;EACjC,8BAA8B;AAChC;;AAEA;EACE,0DAA0D;EAC1D,MAAM;EACN,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA;;EAEE,SAAS;EACT,gBAAgB;EAChB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,mCAAmC;EACnC,iDAAiD;AACnD;;AAEA;EACE;;0FAEwF;AAC1F;;AAEA;EACE,gBAAgB;EAChB,SAAS;AACX;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,0CAA0C;EAC1C,8BAA8B;AAChC;;AAEA;EACE,uBAAuB;AACzB;;AAEA,yEAAyE;AACzE;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,oBAAoB;EACpB,uBAAuB;EACvB,yBAAyB;EACzB,gBAAgB;EAChB,yCAAyC;EACzC,4CAA4C;EAC5C,6CAA6C;EAC7C,wBAAwB;EACxB,2BAA2B;EAC3B,mCAAmC;EACnC,gCAAgC;EAChC,gGAAgG;AAClG;;AAEA;EACE,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;EAC5C,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,wBAAwB;EACxB,0BAA0B;EAC1B,wBAAwB;EACxB,sDAAsD;EACtD,iBAAiB;EACjB,oBAAoB;EACpB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;;EAEE,wBAAwB;EACxB,oBAAoB;EACpB,2BAA2B;EAC3B,2BAA2B;EAC3B,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;EACxB,iCAAiC;EACjC,qBAAqB;EACrB,2BAA2B;EAC3B,wCAAwC;EACxC,mDAAmD;AACrD;;AAEA;EACE,6BAA6B;EAC7B,wBAAwB;EACxB,4DAA4D;EAC5D,2BAA2B;EAC3B;;;wGAGsG;EACtG,wDAAwD;AAC1D;;AAEA;EACE;;;yGAGuG;AACzG;;AAEA;;EAEE,uBAAuB;EACvB,2BAA2B;EAC3B,0BAA0B;EAC1B,uCAAuC;EACvC,oDAAoD;AACtD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;;;;EAKE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;EACpB,6BAA6B;EAC7B,iCAAiC;EACjC,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;;;;EAIE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;;;EAGE,wCAAwC;AAC1C;;AAEA;EACE,uBAAuB;EACvB,oBAAoB;EACpB,8BAA8B;EAC9B,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,8BAA8B;EAC9B,iCAAiC;EACjC,kCAAkC;AACpC;;AAEA;EACE,kCAAkC;EAClC,8CAA8C;AAChD;;AAEA;EACE,oBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;;EAEE,6BAA6B;EAC7B,sBAAsB;EACtB,2BAA2B;EAC3B,oBAAoB;EACpB,2BAA2B;EAC3B,0DAA0D;EAC1D,oBAAoB;EACpB,4BAA4B;EAC5B,gCAAgC;EAChC,kCAAkC;AACpC;;AAEA;;EAEE,sBAAsB;EACtB,6BAA6B;EAC7B,qBAAqB;EACrB,mBAAmB;EACnB,oBAAoB;EACpB,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,8CAA8C;AAChD;;AAEA;EACE,8CAA8C;AAChD;;AAEA;;EAEE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;;EAEE,iCAAiC;EACjC,0BAA0B;AAC5B;;AAEA;EACE,wBAAwB;EACxB,iEAAiE;EACjE,yBAAyB;EACzB,kCAAkC;AACpC;;AAEA;EACE,2BAA2B;EAC3B,8BAA8B;EAC9B,0BAA0B;EAC1B,+CAA+C;EAC/C,qCAAqC;AACvC;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,qCAAqC;EACrC,oBAAoB;EACpB,8BAA8B;EAC9B,+BAA+B;EAC/B,gCAAgC;EAChC,mDAAmD;EACnD,mFAAmF;AACrF;;AAEA;EACE,yCAAyC;EACzC,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,4CAA4C;AAC9C;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,oBAAoB;EACpB,qBAAqB;EACrB,oBAAoB;EACpB,+DAA+D;EAC/D,oGAAoG;AACtG;;AAEA;EACE,sBAAsB;EACtB,0BAA0B;EAC1B,oBAAoB;EACpB,2BAA2B;EAC3B,wBAAwB;EACxB,oEAAoE;EACpE,2BAA2B;EAC3B,mBAAmB;EACnB,oBAAoB;EACpB,kCAAkC;EAClC,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;EAC3B,4BAA4B;EAC5B,oBAAoB;EACpB,8BAA8B;EAC9B,uBAAuB;EACvB,6BAA6B;EAC7B,sCAAsC;EACtC,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,0BAA0B;EAC1B,oBAAoB;EACpB,6BAA6B;EAC7B,uCAAuC;EACvC,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;;;EAGE,8BAA8B;AAChC;;AAEA;EACE,6BAA6B;EAC7B,qDAAqD;EACrD,uBAAuB;EACvB,qBAAqB;EACrB,sCAAsC;EACtC,uDAAuD;AACzD;;AAEA;EACE,8BAA8B;EAC9B,6BAA6B;EAC7B,iCAAiC;EACjC,+CAA+C;AACjD;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;EACnB,wBAAwB;EACxB,wBAAwB;EACxB,kCAAkC;EAClC,mEAAmE;EACnE,yCAAyC;EACzC,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;EAClC,4BAA4B;EAC5B,yBAAyB;EACzB,8BAA8B;EAC9B,wBAAwB;EACxB,gDAAgD;EAChD,yBAAyB;EACzB,kCAAkC;EAClC,sBAAsB;EACtB,4CAA4C;AAC9C;;AAEA;EACE,oBAAoB;EACpB,wBAAwB;EACxB,gCAAgC;EAChC,mBAAmB;EACnB,sBAAsB;EACtB,kCAAkC;AACpC;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;EACvB,6BAA6B;EAC7B,+BAA+B;EAC/B,8BAA8B;EAC9B,kCAAkC;EAClC,sBAAsB;AACxB;;AAEA,8BAA8B,gEAAgE,EAAE;AAChG,gCAAgC,gEAAgE,EAAE;AAClG,gCAAgC,gEAAgE,EAAE;;AAElG;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,oBAAoB;EACpB,8BAA8B;EAC9B,kCAAkC;EAClC,4CAA4C;EAC5C,0BAA0B;AAC5B;;AAEA;;;;EAIE,6BAA6B;EAC7B,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;;;;EAIE,sBAAsB;EACtB,6BAA6B;EAC7B,mBAAmB;EACnB,uCAAuC;EACvC,gGAAgG;EAChG,iEAAiE;AACnE;;AAEA;EACE,iCAAiC;EACjC,2BAA2B;EAC3B,8BAA8B;EAC9B,wBAAwB;EACxB,gCAAgC;EAChC,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+BAA+B;EAC/B,6CAA6C;AAC/C;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE;IACE,uBAAuB;IACvB,qCAAqC;EACvC;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,uBAAuB;IACvB,4DAA4D;EAC9D;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,gCAAgC;EAClC;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,mEAAmE;EACrE;;EAEA;IACE,oEAAoE;IACpE,8BAA8B;EAChC;AACF;;AAEA,kBAAkB,YAAY,CAAC,OAAO,CAAC,eAAe,CAAC,aAAa,CAAC,aAAa,CAAC,kBAAkB,CAAC,WAAW,CAAC,oBAAoB,QAAQ,CAAC,QAAM,CAAC,eAAe,CAAC,WAAW,CAAC,0BAA0B,UAAU,CAAC,eAAe,CAAC,eAAe,CAAC,kBAAkB,CAAC,+BAA+B,WAAW,CAAC,cAAc","sourcesContent":[".chats-page {\n  --chat-page-bg:\n    radial-gradient(circle at top left, rgba(255, 255, 255, 0.42), transparent 28%),\n    linear-gradient(180deg, #6cb7ff 0%, #58a5f4 38%, #4798e9 100%);\n  --chat-shell-surface: rgba(245, 249, 255, 0.78);\n  --chat-shell-border: rgba(255, 255, 255, 0.46);\n  --chat-shell-shadow: 0 22px 60px rgba(15, 58, 109, 0.16);\n  --chat-text: #122338;\n  --chat-muted: #6282a4;\n  --chat-strong: #0f2843;\n  --chat-soft-surface: rgba(255, 255, 255, 0.88);\n  --chat-soft-surface-2: rgba(255, 255, 255, 0.92);\n  --chat-soft-hover: rgba(255, 255, 255, 0.52);\n  --chat-active: rgba(255, 255, 255, 0.88);\n  --chat-active-ring: inset 0 0 0 1px rgba(63, 144, 224, 0.18);\n  --chat-header-bg: rgba(234, 244, 255, 0.82);\n  --chat-header-border: rgba(25, 71, 116, 0.08);\n  --chat-panel-bg:\n    linear-gradient(rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.12)),\n    radial-gradient(circle at top left, rgba(255, 255, 255, 0.2), transparent 22%);\n  --chat-bubble-other: rgba(255, 255, 255, 0.96);\n  --chat-bubble-mine: linear-gradient(180deg, #42a6ff, #1b86ef);\n  --chat-composer-bg: rgba(255, 255, 255, 0.88);\n  --chat-modal-bg: #f4f9ff;\n  --chat-modal-overlay: rgba(11, 32, 56, 0.32);\n  min-height: 100vh;\n  background: var(--chat-page-bg);\n  color: var(--chat-text);\n  font-family: \"Manrope\", \"Segoe UI\", sans-serif;\n}\n\n/* Telegram-like regular chat overrides */\n.chats-page {\n  --tg-bg: #e7eef5;\n  --tg-sidebar: #ffffff;\n  --tg-panel: #ffffff;\n  --tg-header: rgba(255, 255, 255, 0.96);\n  --tg-border: #dfe7ef;\n  --tg-text: #17212b;\n  --tg-muted: #6f8396;\n  --tg-accent: #2aabee;\n  --tg-bubble-other: #ffffff;\n  --tg-bubble-mine: #effdde;\n  min-height: 100dvh;\n  background: var(--tg-bg);\n  color: var(--tg-text);\n}\n\nbody[data-theme=\"dark\"] .chats-page {\n  --tg-bg: #0e1621;\n  --tg-sidebar: #17212b;\n  --tg-panel: #17212b;\n  --tg-header: rgba(23, 33, 43, 0.96);\n  --tg-border: #263542;\n  --tg-text: #eef6fc;\n  --tg-muted: #8aa0b3;\n  --tg-bubble-other: #182533;\n  --tg-bubble-mine: #2b5278;\n}\n\n.chats-shell {\n  grid-template-columns: minmax(300px, 368px) minmax(0, 1fr);\n  gap: 0;\n  max-width: none;\n  min-height: 100dvh;\n  padding: 0;\n}\n\n.chats-sidebar,\n.chats-main {\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  backdrop-filter: none;\n}\n\n.chats-sidebar {\n  background: var(--tg-sidebar);\n  border-right: 1px solid var(--tg-border);\n}\n\n.chats-main {\n  background:\n    linear-gradient(rgba(231, 238, 245, 0.84), rgba(231, 238, 245, 0.84)),\n    repeating-linear-gradient(45deg, rgba(42, 171, 238, 0.04) 0 1px, transparent 1px 18px);\n}\n\nbody[data-theme=\"dark\"] .chats-main {\n  background:\n    linear-gradient(rgba(14, 22, 33, 0.9), rgba(14, 22, 33, 0.9)),\n    repeating-linear-gradient(45deg, rgba(255, 255, 255, 0.025) 0 1px, transparent 1px 18px);\n}\n\n.chats-sidebar-top,\n.chats-header,\n.pinned-message-bar {\n  background: var(--tg-header);\n  border-bottom: 1px solid var(--tg-border);\n}\n\n.chats-brand {\n  display: none;\n}\n\n.chats-filter-row {\n  display: flex;\n  gap: 8px;\n  overflow: auto;\n  padding: 0 14px 10px;\n}\n\n.chat-filter-chip {\n  border: 1px solid var(--tg-border);\n  border-radius: 999px;\n  background: transparent;\n  color: var(--tg-muted);\n  padding: 8px 10px;\n  display: inline-flex;\n  gap: 6px;\n}\n\n.chat-filter-chip.active {\n  color: var(--tg-accent);\n  background: rgba(42, 171, 238, 0.12);\n}\n\n.chat-row {\n  border-radius: 0;\n  border: 0;\n}\n\n.chat-row-pin,\n.message-pin-mark {\n  display: inline-flex;\n  width: 14px;\n  height: 14px;\n  color: var(--tg-accent);\n}\n\n.chat-row-pin.important,\n.message-pin-mark.important {\n  color: #e8a800;\n}\n\n.pinned-message-bar {\n  width: 100%;\n  border-left: 0;\n  border-right: 0;\n  border-top: 0;\n  color: var(--tg-text);\n  display: grid;\n  grid-template-columns: 32px minmax(0, 1fr);\n  gap: 8px;\n  padding: 8px 18px;\n  text-align: left;\n}\n\n.pinned-message-icon {\n  color: var(--tg-accent);\n}\n\n.pinned-message-copy {\n  display: grid;\n  min-width: 0;\n}\n\n.pinned-message-copy strong,\n.pinned-message-copy span {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.message-bubble.other {\n  background: var(--tg-bubble-other);\n}\n\n.message-bubble.mine {\n  background: var(--tg-bubble-mine);\n  color: var(--tg-text);\n}\n\n.message-reply-preview,\n.message-forwarded,\n.link-preview-card {\n  border-left: 3px solid var(--tg-accent);\n  background: rgba(42, 171, 238, 0.08);\n  border-radius: 7px;\n  padding: 6px 8px;\n  margin-bottom: 6px;\n}\n\n.message-forwarded {\n  display: inline-flex;\n  align-items: center;\n  gap: 6px;\n  color: var(--tg-muted);\n  font-size: 12px;\n}\n\n.message-text {\n  overflow-wrap: anywhere;\n}\n\n.message-text code {\n  border-radius: 5px;\n  padding: 1px 4px;\n  background: rgba(0, 0, 0, 0.08);\n}\n\n.message-text pre {\n  overflow: auto;\n  border-radius: 8px;\n  padding: 8px;\n  background: rgba(0, 0, 0, 0.08);\n}\n\n.link-preview-card {\n  display: grid;\n  text-decoration: none;\n}\n\n.link-preview-domain {\n  color: var(--tg-accent);\n  font-weight: 700;\n}\n\n.link-preview-url {\n  color: var(--tg-muted);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.message-reactions,\n.reaction-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n  margin-top: 6px;\n}\n\n.message-reaction,\n.reaction-choice {\n  border: 0;\n  border-radius: 999px;\n  background: rgba(42, 171, 238, 0.14);\n  padding: 4px 8px;\n}\n\n.reaction-choice {\n  font-size: 18px;\n  width: 38px;\n  height: 34px;\n}\n\n.composer {\n  background: transparent;\n}\n\n/* Support /chats final native lock. Kept at EOF to override the older desktop card skin above. */\n.pageContentInner:has(> .chats-page) {\n  padding: 0 !important;\n}\n\n.chats-page {\n  --tg-bg: #dbe7f3;\n  --tg-sidebar: #fff;\n  --tg-panel: #fff;\n  --tg-header: #fff;\n  --tg-border: #d3dde8;\n  --tg-text: #17212b;\n  --tg-muted: #6d7f90;\n  --tg-accent: #2aabee;\n  --tg-bubble-other: #fff;\n  --tg-bubble-mine: #dff7c7;\n  --tg-input: #fff;\n  --tg-skeleton-base: rgba(23, 33, 43, .08);\n  --tg-skeleton-peak: rgba(255, 255, 255, .72);\n  width: 100% !important;\n  height: calc(var(--vh, 1vh) * 100) !important;\n  min-height: 0 !important;\n  overflow: hidden !important;\n  background: var(--tg-bg) !important;\n  color: var(--tg-text) !important;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif !important;\n}\n\nbody[data-theme=\"dark\"] .chats-page {\n  --tg-bg: #0e1621;\n  --tg-sidebar: #17212b;\n  --tg-panel: #17212b;\n  --tg-header: #17212b;\n  --tg-border: #0b1118;\n  --tg-text: #eef6fc;\n  --tg-muted: #7f91a4;\n  --tg-bubble-other: #182533;\n  --tg-bubble-mine: #2b5278;\n  --tg-input: #242f3d;\n  --tg-skeleton-base: rgba(255, 255, 255, .07);\n  --tg-skeleton-peak: rgba(255, 255, 255, .16);\n}\n\n.chats-shell {\n  width: 100% !important;\n  height: 100% !important;\n  min-height: 0 !important;\n  display: grid !important;\n  grid-template-columns: 360px minmax(0, 1fr) !important;\n  gap: 0 !important;\n  max-width: none !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n}\n\n.chats-sidebar,\n.chats-main {\n  min-height: 0 !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  backdrop-filter: none !important;\n}\n\n.chats-sidebar {\n  display: flex !important;\n  flex-direction: column !important;\n  padding: 0 !important;\n  gap: 0 !important;\n  overflow: hidden !important;\n  background: var(--tg-sidebar) !important;\n  border-right: 1px solid var(--tg-border) !important;\n}\n\n.chats-main {\n  position: relative !important;\n  display: grid !important;\n  grid-template-rows: 56px auto minmax(0, 1fr) auto !important;\n  overflow: hidden !important;\n  background:\n    linear-gradient(rgba(219, 231, 243, .84), rgba(219, 231, 243, .84)),\n    radial-gradient(circle at 24px 24px, rgba(49, 102, 139, .075) 0 1.2px, transparent 1.4px),\n    radial-gradient(circle at 76px 84px, rgba(49, 102, 139, .055) 0 1.6px, transparent 1.8px) !important;\n  background-size: auto, 68px 68px, 112px 112px !important;\n}\n\nbody[data-theme=\"dark\"] .chats-main {\n  background:\n    linear-gradient(rgba(14, 22, 33, .9), rgba(14, 22, 33, .9)),\n    radial-gradient(circle at 24px 24px, rgba(255, 255, 255, .045) 0 1.2px, transparent 1.4px),\n    radial-gradient(circle at 76px 84px, rgba(255, 255, 255, .035) 0 1.6px, transparent 1.8px) !important;\n}\n\n.chats-sidebar-top,\n.chats-header {\n  height: 56px !important;\n  min-height: 56px !important;\n  padding: 0 12px !important;\n  background: var(--tg-header) !important;\n  border-bottom: 1px solid var(--tg-border) !important;\n}\n\n.chats-brand {\n  display: none !important;\n}\n\n.chats-sidebar-title {\n  color: var(--tg-text) !important;\n  font-size: 19px !important;\n  font-weight: 700 !important;\n}\n\n.round-action,\n.icon-button,\n.composer-tool,\n.jump-to-bottom,\n.message-action-button {\n  width: 40px !important;\n  height: 40px !important;\n  min-width: 40px !important;\n  border: 0 !important;\n  border-radius: 50% !important;\n  color: var(--tg-muted) !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.round-action:hover,\n.icon-button:hover,\n.icon-button.active,\n.composer-tool:hover {\n  color: var(--tg-accent) !important;\n  background: rgba(42, 171, 238, .12) !important;\n}\n\n.chats-search-wrap,\n.chats-filter-row {\n  background: var(--tg-sidebar) !important;\n}\n\n.chats-search {\n  height: 36px !important;\n  border: 0 !important;\n  border-radius: 18px !important;\n  background: var(--tg-input) !important;\n}\n\n.chat-filter-chip {\n  min-height: 30px !important;\n  border: 0 !important;\n  border-radius: 15px !important;\n  color: var(--tg-muted) !important;\n  background: transparent !important;\n}\n\n.chat-filter-chip.active {\n  color: var(--tg-accent) !important;\n  background: rgba(42, 171, 238, .14) !important;\n}\n\n.chats-list {\n  flex: 1 !important;\n  min-height: 0 !important;\n  gap: 0 !important;\n  padding: 0 !important;\n  overflow: auto !important;\n  background: var(--tg-sidebar) !important;\n}\n\n.chat-row,\n.chat-row-skeleton {\n  position: relative !important;\n  width: 100% !important;\n  min-height: 72px !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  grid-template-columns: 54px minmax(0, 1fr) auto !important;\n  gap: 10px !important;\n  padding: 8px 12px !important;\n  color: var(--tg-text) !important;\n  background: transparent !important;\n}\n\n.chat-row::after,\n.chat-row-skeleton::after {\n  content: \"\" !important;\n  position: absolute !important;\n  left: 76px !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  height: 1px !important;\n  background: rgba(23, 33, 43, .08) !important;\n}\n\n.chat-row:hover {\n  background: rgba(42, 171, 238, .07) !important;\n}\n\n.chat-row.active {\n  background: rgba(42, 171, 238, .14) !important;\n}\n\n.chat-avatar,\n.skeleton-avatar {\n  width: 50px !important;\n  height: 50px !important;\n  border-radius: 50% !important;\n}\n\n.chat-row-title {\n  color: var(--tg-text) !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n}\n\n.chat-row-preview,\n.chat-row-time {\n  color: var(--tg-muted) !important;\n  font-size: 13px !important;\n}\n\n.messages-panel {\n  min-height: 0 !important;\n  padding: 14px max(12px, calc((100% - 920px) / 2)) 10px !important;\n  overflow: auto !important;\n  scroll-behavior: smooth !important;\n}\n\n.messages-date-divider span {\n  min-height: 26px !important;\n  border-radius: 13px !important;\n  padding: 0 12px !important;\n  background: rgba(109, 127, 144, .58) !important;\n  backdrop-filter: blur(8px) !important;\n}\n\n.message-row.mine {\n  align-items: flex-end !important;\n}\n\n.message-row.other {\n  align-items: flex-start !important;\n}\n\n.message-bubble {\n  max-width: min(620px, 78%) !important;\n  border: 0 !important;\n  border-radius: 11px !important;\n  padding: 6px 8px 4px !important;\n  color: var(--tg-text) !important;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, .18) !important;\n  animation: telegram-message-in .2s cubic-bezier(.18, .9, .22, 1.12) both !important;\n}\n\n.message-bubble.other {\n  border-bottom-left-radius: 3px !important;\n  background: var(--tg-bubble-other) !important;\n}\n\n.message-bubble.mine {\n  border-bottom-right-radius: 3px !important;\n  background: var(--tg-bubble-mine) !important;\n}\n\n.message-text {\n  color: var(--tg-text) !important;\n  font-size: 16px !important;\n  line-height: 1.36 !important;\n}\n\n.composer {\n  position: sticky !important;\n  bottom: 0 !important;\n  z-index: 4 !important;\n  border: 0 !important;\n  padding: 7px max(8px, calc((100% - 940px) / 2)) 10px !important;\n  background: linear-gradient(180deg, rgba(219, 231, 243, 0), rgba(219, 231, 243, .96) 22%) !important;\n}\n\n.composer-shell {\n  width: 100% !important;\n  max-width: none !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  display: grid !important;\n  grid-template-columns: 40px 40px minmax(0, 1fr) 40px 46px !important;\n  align-items: end !important;\n  gap: 6px !important;\n  margin: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.composer-input {\n  min-height: 42px !important;\n  max-height: 140px !important;\n  border: 0 !important;\n  border-radius: 21px !important;\n  resize: none !important;\n  padding: 11px 14px !important;\n  background: var(--tg-input) !important;\n  color: var(--tg-text) !important;\n  font-size: 15px !important;\n}\n\n.composer-send {\n  width: 44px !important;\n  height: 44px !important;\n  min-width: 44px !important;\n  border: 0 !important;\n  border-radius: 50% !important;\n  background: var(--tg-accent) !important;\n  color: #fff !important;\n  box-shadow: none !important;\n}\n\n.composer-editing,\n.composer-attachments,\n.emoji-panel {\n  grid-column: 1 / -1 !important;\n}\n\n.jump-to-bottom {\n  position: absolute !important;\n  right: max(16px, calc((100% - 920px) / 2)) !important;\n  bottom: 74px !important;\n  z-index: 8 !important;\n  background: var(--tg-panel) !important;\n  box-shadow: 0 4px 14px rgba(23, 33, 43, .18) !important;\n}\n\n.chats-empty {\n  border-radius: 14px !important;\n  padding: 16px 18px !important;\n  color: var(--tg-muted) !important;\n  background: rgba(255, 255, 255, .78) !important;\n}\n\n.settings-status {\n  color: var(--tg-muted);\n  font-size: 13px;\n  padding: 0 4px;\n}\n\n.settings-mute-options,\n.settings-counters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.chat-sheet,\n.chats-modal {\n  position: fixed !important;\n  inset: 0 !important;\n  z-index: 2000 !important;\n  display: grid !important;\n  place-items: end center !important;\n  padding: 0 10px calc(10px + env(safe-area-inset-bottom)) !important;\n  background: rgba(0, 0, 0, .52) !important;\n  backdrop-filter: blur(14px) !important;\n}\n\n.attachment-sheet-grid {\n  width: min(430px, 100%) !important;\n  max-height: 82dvh !important;\n  overflow: auto !important;\n  border-radius: 18px !important;\n  display: grid !important;\n  grid-template-columns: repeat(3, 1fr) !important;\n  gap: 20px 12px !important;\n  padding: 28px 18px 24px !important;\n  color: #fff !important;\n  background: rgba(33, 35, 39, .96) !important;\n}\n\n.attachment-sheet-grid button {\n  border: 0 !important;\n  display: grid !important;\n  justify-items: center !important;\n  gap: 8px !important;\n  color: #fff !important;\n  background: transparent !important;\n}\n\n.attachment-sheet-icon {\n  width: 52px !important;\n  height: 52px !important;\n  border-radius: 50% !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: #fff !important;\n}\n\n.attachment-sheet-icon.blue { background: linear-gradient(135deg, #2f80ed, #3b9bff) !important; }\n.attachment-sheet-icon.purple { background: linear-gradient(135deg, #7c3aed, #a855f7) !important; }\n.attachment-sheet-icon.orange { background: linear-gradient(135deg, #f59e0b, #fb923c) !important; }\n\n.attachment-sheet-cancel {\n  width: min(430px, 100%) !important;\n  min-height: 54px !important;\n  border: 0 !important;\n  border-radius: 14px !important;\n  color: var(--tg-accent) !important;\n  background: rgba(33, 35, 39, .96) !important;\n  font-size: 16px !important;\n}\n\n.skeleton-avatar,\n.skeleton-line,\n.skeleton-date-pill,\n.message-skeleton-bubble {\n  position: relative !important;\n  overflow: hidden !important;\n  background: var(--tg-skeleton-base) !important;\n}\n\n.skeleton-avatar::after,\n.skeleton-line::after,\n.skeleton-date-pill::after,\n.message-skeleton-bubble::after {\n  content: \"\" !important;\n  position: absolute !important;\n  inset: 0 !important;\n  transform: translateX(-100%) !important;\n  background: linear-gradient(90deg, transparent, var(--tg-skeleton-peak), transparent) !important;\n  animation: skeleton-shimmer 1.25s ease-in-out infinite !important;\n}\n\n.message-skeleton-bubble {\n  width: min(360px, 68%) !important;\n  min-height: 56px !important;\n  border-radius: 13px !important;\n  display: grid !important;\n  align-content: center !important;\n  gap: 8px !important;\n  padding: 12px !important;\n}\n\n.message-skeleton-bubble.other {\n  align-self: flex-start !important;\n}\n\n.message-skeleton-bubble.mine {\n  align-self: flex-end !important;\n  background: rgba(91, 185, 74, .16) !important;\n}\n\n.message-skeleton-bubble.wide {\n  width: min(470px, 78%) !important;\n}\n\n@media (max-width: 760px) {\n  .chats-shell {\n    height: 100% !important;\n    grid-template-columns: 1fr !important;\n  }\n\n  .chats-sidebar.hidden,\n  .chats-main.hidden {\n    display: none !important;\n  }\n\n  .chats-sidebar {\n    border-right: 0 !important;\n  }\n\n  .chats-main {\n    height: 100% !important;\n    grid-template-rows: 56px auto minmax(0, 1fr) auto !important;\n  }\n\n  .header-actions .optional-mobile-action {\n    display: none !important;\n  }\n\n  .messages-panel {\n    padding: 10px 8px 8px !important;\n  }\n\n  .message-bubble {\n    max-width: 86% !important;\n  }\n\n  .composer {\n    padding: 6px 8px calc(8px + env(safe-area-inset-bottom)) !important;\n  }\n\n  .composer-shell {\n    grid-template-columns: 38px 38px minmax(0, 1fr) 38px 44px !important;\n    align-items: center !important;\n  }\n}\n\n.call-header-button {\n  color: #0b8f4d !important;\n}\n\n.call-header-button.active {\n  background: rgba(39, 167, 231, 0.14) !important;\n  color: #0088cc !important;\n}\n\n.chat-call-panel {\n  margin: 10px 14px 0 !important;\n  padding: 12px !important;\n  display: grid !important;\n  grid-template-columns: 42px minmax(0, 1fr) auto !important;\n  align-items: center !important;\n  gap: 12px !important;\n  border: 1px solid rgba(39, 167, 231, 0.18) !important;\n  border-radius: 18px !important;\n  background: rgba(255, 255, 255, 0.96) !important;\n  box-shadow: 0 8px 24px rgba(18, 44, 74, 0.08) !important;\n  color: #111 !important;\n}\n\n.chat-call-panel.incoming {\n  border-color: rgba(11, 143, 77, 0.24) !important;\n  background: linear-gradient(180deg, #fff, #f2fbf7) !important;\n}\n\n.chat-call-panel.active {\n  background: linear-gradient(180deg, #fff, #f0f9ff) !important;\n}\n\n.chat-call-panel.connected {\n  border-color: rgba(11, 143, 77, 0.28) !important;\n}\n\n.chat-call-panel.failed {\n  border-color: rgba(219, 67, 67, 0.26) !important;\n  background: linear-gradient(180deg, #fff, #fff4f4) !important;\n}\n\n.chat-call-avatar {\n  width: 42px !important;\n  height: 42px !important;\n  border-radius: 21px !important;\n  display: grid !important;\n  place-items: center !important;\n  background: #27a7e7 !important;\n  color: #fff !important;\n}\n\n.chat-call-panel.incoming .chat-call-avatar,\n.chat-call-panel.connected .chat-call-avatar {\n  background: #0b8f4d !important;\n}\n\n.chat-call-panel.failed .chat-call-avatar {\n  background: #d84444 !important;\n}\n\n.chat-call-copy {\n  min-width: 0 !important;\n  display: grid !important;\n  gap: 3px !important;\n}\n\n.chat-call-copy strong {\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n  font-size: 14px !important;\n  font-weight: 800 !important;\n  color: #111 !important;\n}\n\n.chat-call-copy span {\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  white-space: nowrap !important;\n  font-size: 13px !important;\n  color: #707579 !important;\n}\n\n.chat-call-actions {\n  display: flex !important;\n  align-items: center !important;\n  gap: 8px !important;\n}\n\n.call-action {\n  min-height: 38px !important;\n  padding: 0 12px !important;\n  border: 0 !important;\n  border-radius: 19px !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  gap: 7px !important;\n  font-size: 13px !important;\n  font-weight: 800 !important;\n  cursor: pointer !important;\n}\n\n.call-action.accept {\n  background: #0b8f4d !important;\n  color: #fff !important;\n}\n\n.call-action.decline {\n  background: #e94b4b !important;\n  color: #fff !important;\n}\n\n.call-action.muted {\n  background: #f1f3f5 !important;\n  color: #111 !important;\n}\n\n.call-action.muted.active {\n  background: #fff0f0 !important;\n  color: #d84444 !important;\n}\n\n.call-action:disabled {\n  opacity: 0.56 !important;\n  cursor: default !important;\n}\n\n.chat-call-sound {\n  width: fit-content !important;\n  padding: 0 !important;\n  border: 0 !important;\n  background: transparent !important;\n  color: #0088cc !important;\n  font-size: 12px !important;\n  font-weight: 800 !important;\n  text-align: left !important;\n  cursor: pointer !important;\n}\n\n@media (max-width: 760px) {\n  .chat-call-panel {\n    margin: 8px 8px 0 !important;\n    grid-template-columns: 38px minmax(0, 1fr) !important;\n  }\n\n  .chat-call-actions {\n    grid-column: 1 / -1 !important;\n    justify-content: stretch !important;\n  }\n\n  .call-action {\n    flex: 1 1 0 !important;\n  }\n}\n\n/* Native Telegram-like final pass for ordinary /chats */\n.pageContentInner:has(> .chats-page) {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.chats-page {\n  --tg-bg: #dbe7f3;\n  --tg-sidebar: #fff;\n  --tg-panel: #fff;\n  --tg-header: #fff;\n  --tg-border: #d3dde8;\n  --tg-text: #17212b;\n  --tg-muted: #6d7f90;\n  --tg-accent: #2aabee;\n  --tg-bubble-other: #fff;\n  --tg-bubble-mine: #dff7c7;\n  --tg-bubble-mine-border: #c9edaa;\n  --tg-input: #fff;\n  --tg-skeleton-base: rgba(23, 33, 43, .08);\n  --tg-skeleton-peak: rgba(255, 255, 255, .72);\n  width: 100%;\n  height: calc(var(--vh, 1vh) * 100);\n  min-height: 0;\n  overflow: hidden;\n  background: var(--tg-bg);\n  color: var(--tg-text);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif;\n}\n\nbody[data-theme=\"dark\"] .chats-page {\n  --tg-bg: #0e1621;\n  --tg-sidebar: #17212b;\n  --tg-panel: #17212b;\n  --tg-header: #17212b;\n  --tg-border: #0b1118;\n  --tg-text: #eef6fc;\n  --tg-muted: #7f91a4;\n  --tg-bubble-other: #182533;\n  --tg-bubble-mine: #2b5278;\n  --tg-bubble-mine-border: #2b5278;\n  --tg-input: #242f3d;\n  --tg-skeleton-base: rgba(255, 255, 255, .07);\n  --tg-skeleton-peak: rgba(255, 255, 255, .16);\n}\n\n.chats-shell {\n  width: 100%;\n  height: 100%;\n  min-height: 0;\n  display: grid;\n  grid-template-columns: 360px minmax(0, 1fr);\n  gap: 0;\n  padding: 0;\n  margin: 0;\n  overflow: hidden;\n}\n\n.chats-sidebar,\n.chats-main {\n  min-height: 0;\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  backdrop-filter: none;\n}\n\n.chats-sidebar {\n  display: flex;\n  flex-direction: column;\n  padding: 0;\n  gap: 0;\n  background: var(--tg-sidebar);\n  border-right: 1px solid var(--tg-border);\n}\n\n.chats-main {\n  position: relative;\n  display: grid;\n  grid-template-rows: 56px auto minmax(0, 1fr) auto;\n  overflow: hidden;\n  background:\n    linear-gradient(rgba(219, 231, 243, .84), rgba(219, 231, 243, .84)),\n    radial-gradient(circle at 24px 24px, rgba(49, 102, 139, .075) 0 1.2px, transparent 1.4px),\n    radial-gradient(circle at 76px 84px, rgba(49, 102, 139, .055) 0 1.6px, transparent 1.8px);\n  background-size: auto, 68px 68px, 112px 112px;\n}\n\nbody[data-theme=\"dark\"] .chats-main {\n  background:\n    linear-gradient(rgba(14, 22, 33, .9), rgba(14, 22, 33, .9)),\n    radial-gradient(circle at 24px 24px, rgba(255, 255, 255, .045) 0 1.2px, transparent 1.4px),\n    radial-gradient(circle at 76px 84px, rgba(255, 255, 255, .035) 0 1.6px, transparent 1.8px);\n  background-size: auto, 68px 68px, 112px 112px;\n}\n\n.chats-sidebar-top,\n.chats-header {\n  height: 56px;\n  min-height: 56px;\n  padding: 0 12px;\n  background: var(--tg-header);\n  border-bottom: 1px solid var(--tg-border);\n}\n\n.chats-brand {\n  display: none !important;\n}\n\n.chats-sidebar-title {\n  color: var(--tg-text);\n  font-size: 19px;\n  font-weight: 700;\n}\n\n.round-action,\n.icon-button,\n.composer-tool,\n.jump-to-bottom,\n.message-action-button {\n  width: 40px;\n  height: 40px;\n  min-width: 40px;\n  border: 0;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: var(--tg-muted);\n  background: transparent;\n  box-shadow: none;\n}\n\n.round-action:hover,\n.icon-button:hover,\n.icon-button.active,\n.composer-tool:hover {\n  color: var(--tg-accent);\n  background: rgba(42, 171, 238, .12);\n}\n\n.chats-search-wrap,\n.chats-filter-row {\n  background: var(--tg-sidebar);\n}\n\n.chats-search {\n  height: 36px;\n  border: 0;\n  border-radius: 18px;\n  background: var(--tg-input);\n}\n\n.chat-filter-chip {\n  min-height: 30px;\n  border: 0;\n  border-radius: 15px;\n  color: var(--tg-muted);\n  background: transparent;\n}\n\n.chat-filter-chip.active {\n  color: var(--tg-accent);\n  background: rgba(42, 171, 238, .14);\n}\n\n.chats-list {\n  flex: 1;\n  min-height: 0;\n  gap: 0;\n  padding: 0;\n  overflow: auto;\n  background: var(--tg-sidebar);\n}\n\n.chat-row,\n.chat-row-skeleton {\n  position: relative;\n  width: 100%;\n  min-height: 72px;\n  border: 0;\n  border-radius: 0;\n  grid-template-columns: 54px minmax(0, 1fr) auto;\n  gap: 10px;\n  padding: 8px 12px;\n  color: var(--tg-text);\n  background: transparent;\n}\n\n.chat-row::after,\n.chat-row-skeleton::after {\n  content: \"\";\n  position: absolute;\n  left: 76px;\n  right: 0;\n  bottom: 0;\n  height: 1px;\n  background: rgba(23, 33, 43, .08);\n}\n\nbody[data-theme=\"dark\"] .chat-row::after,\nbody[data-theme=\"dark\"] .chat-row-skeleton::after {\n  background: rgba(255, 255, 255, .045);\n}\n\n.chat-row:hover {\n  background: rgba(42, 171, 238, .07);\n}\n\n.chat-row.active {\n  background: rgba(42, 171, 238, .14);\n}\n\n.chat-avatar,\n.skeleton-avatar {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n}\n\n.chat-row-title {\n  color: var(--tg-text);\n  font-size: 15px;\n  font-weight: 600;\n}\n\n.chat-row-preview,\n.chat-row-time {\n  color: var(--tg-muted);\n  font-size: 13px;\n}\n\n.chat-unread-badge {\n  background: #4dcd5e;\n}\n\n.messages-panel {\n  min-height: 0;\n  padding: 14px max(12px, calc((100% - 920px) / 2)) 10px;\n  overflow: auto;\n  scroll-behavior: smooth;\n}\n\n.message-list-skeleton {\n  min-height: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n}\n\n.messages-date-divider span {\n  min-height: 26px;\n  border-radius: 13px;\n  padding: 0 12px;\n  background: rgba(109, 127, 144, .58);\n  backdrop-filter: blur(8px);\n}\n\n.message-row {\n  display: flex;\n  flex-direction: column;\n}\n\n.message-row.mine {\n  align-items: flex-end;\n}\n\n.message-row.other {\n  align-items: flex-start;\n}\n\n.message-bubble {\n  max-width: min(620px, 78%);\n  border: 0;\n  border-radius: 11px;\n  padding: 6px 8px 4px;\n  color: var(--tg-text);\n  box-shadow: 0 1px 2px rgba(0, 0, 0, .18);\n  animation: telegram-message-in .2s cubic-bezier(.18, .9, .22, 1.12) both;\n}\n\n.message-bubble.other {\n  border-bottom-left-radius: 3px;\n  background: var(--tg-bubble-other);\n}\n\n.message-bubble.mine {\n  border: 0;\n  border-bottom-right-radius: 3px;\n  background: var(--tg-bubble-mine);\n}\n\n.message-text {\n  color: var(--tg-text);\n  font-size: 16px;\n  line-height: 1.36;\n}\n\n.composer {\n  position: sticky;\n  bottom: 0;\n  z-index: 4;\n  border: 0;\n  padding: 7px max(8px, calc((100% - 940px) / 2)) 10px;\n  background: linear-gradient(180deg, rgba(219, 231, 243, 0), rgba(219, 231, 243, .96) 22%);\n}\n\nbody[data-theme=\"dark\"] .composer {\n  background: linear-gradient(180deg, rgba(14, 22, 33, 0), rgba(14, 22, 33, .96) 22%);\n}\n\n.composer-shell {\n  width: 100%;\n  max-width: none;\n  border: 0;\n  border-radius: 0;\n  display: grid;\n  grid-template-columns: 40px 40px minmax(0, 1fr) 40px 46px;\n  align-items: end;\n  gap: 6px;\n  margin: 0;\n  background: transparent;\n  box-shadow: none;\n}\n\n.composer-input {\n  min-height: 42px;\n  max-height: 140px;\n  border: 0;\n  border-radius: 21px;\n  resize: none;\n  padding: 11px 14px;\n  background: var(--tg-input);\n  color: var(--tg-text);\n  font-size: 15px;\n}\n\n.composer-send {\n  width: 44px;\n  height: 44px;\n  min-width: 44px;\n  border: 0;\n  border-radius: 50%;\n  background: var(--tg-accent);\n  color: #fff;\n  box-shadow: none;\n}\n\n.composer-editing,\n.composer-attachments,\n.emoji-panel {\n  grid-column: 1 / -1;\n}\n\n.jump-to-bottom {\n  position: absolute;\n  right: max(16px, calc((100% - 920px) / 2));\n  bottom: 74px;\n  z-index: 8;\n  background: var(--tg-panel);\n  box-shadow: 0 4px 14px rgba(23, 33, 43, .18);\n}\n\n.chats-empty {\n  border-radius: 14px;\n  padding: 16px 18px;\n  color: var(--tg-muted);\n  background: rgba(255, 255, 255, .78);\n}\n\n.chat-sheet,\n.chats-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 2000;\n  display: grid;\n  place-items: end center;\n  padding: 0 10px calc(10px + env(safe-area-inset-bottom));\n  background: rgba(0, 0, 0, .52);\n  backdrop-filter: blur(14px);\n}\n\n.attachment-sheet-grid {\n  width: min(430px, 100%);\n  max-height: 82dvh;\n  overflow: auto;\n  border-radius: 18px;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  gap: 20px 12px;\n  padding: 28px 18px 24px;\n  color: #fff;\n  background: rgba(33, 35, 39, .96);\n}\n\n.attachment-sheet-grid button {\n  border: 0;\n  display: grid;\n  justify-items: center;\n  gap: 8px;\n  color: #fff;\n  background: transparent;\n}\n\n.attachment-sheet-icon {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  color: #fff;\n}\n\n.attachment-sheet-icon.blue { background: linear-gradient(135deg, #2f80ed, #3b9bff); }\n.attachment-sheet-icon.purple { background: linear-gradient(135deg, #7c3aed, #a855f7); }\n.attachment-sheet-icon.orange { background: linear-gradient(135deg, #f59e0b, #fb923c); }\n\n.attachment-sheet-cancel {\n  width: min(430px, 100%);\n  min-height: 54px;\n  border: 0;\n  border-radius: 14px;\n  color: var(--tg-accent);\n  background: rgba(33, 35, 39, .96);\n  font-size: 16px;\n}\n\n.skeleton-avatar,\n.skeleton-line,\n.skeleton-date-pill,\n.message-skeleton-bubble {\n  position: relative;\n  overflow: hidden;\n  background: var(--tg-skeleton-base);\n}\n\n.skeleton-avatar::after,\n.skeleton-line::after,\n.skeleton-date-pill::after,\n.message-skeleton-bubble::after {\n  content: \"\";\n  position: absolute;\n  inset: 0;\n  transform: translateX(-100%);\n  background: linear-gradient(90deg, transparent, var(--tg-skeleton-peak), transparent);\n  animation: skeleton-shimmer 1.25s ease-in-out infinite;\n}\n\n.message-skeleton-bubble {\n  width: min(360px, 68%);\n  min-height: 56px;\n  border-radius: 13px;\n  display: grid;\n  align-content: center;\n  gap: 8px;\n  padding: 12px;\n}\n\n.message-skeleton-bubble.other {\n  align-self: flex-start;\n}\n\n.message-skeleton-bubble.mine {\n  align-self: flex-end;\n  background: rgba(91, 185, 74, .16);\n}\n\n.message-skeleton-bubble.wide {\n  width: min(470px, 78%);\n}\n\n@keyframes skeleton-shimmer {\n  100% { transform: translateX(100%); }\n}\n\n@keyframes telegram-message-in {\n  from { opacity: 0; transform: translateY(8px) scale(.985); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n@media (max-width: 760px) {\n  .chats-shell {\n    height: 100%;\n    grid-template-columns: 1fr;\n  }\n\n  .chats-sidebar.hidden,\n  .chats-main.hidden {\n    display: none !important;\n  }\n\n  .chats-sidebar {\n    border-right: 0;\n  }\n\n  .chats-main {\n    height: 100%;\n    grid-template-rows: 56px auto minmax(0, 1fr) auto;\n  }\n\n  .header-actions .optional-mobile-action {\n    display: none;\n  }\n\n  .messages-panel {\n    padding: 10px 8px 8px;\n  }\n\n  .message-bubble {\n    max-width: 86%;\n  }\n\n  .composer {\n    padding: 6px 8px calc(8px + env(safe-area-inset-bottom));\n  }\n\n  .composer-shell {\n    grid-template-columns: 38px 38px minmax(0, 1fr) 38px 44px;\n    align-items: center;\n  }\n}\n\n.messages-panel.drag-over {\n  outline: 2px dashed var(--tg-accent, #2aabee);\n  outline-offset: -12px;\n}\n\n.attachment-card.media-button {\n  border: 0;\n  padding: 0;\n  cursor: zoom-in;\n}\n\n.emoji-panel {\n  display: flex;\n  gap: 8px;\n  flex-wrap: wrap;\n  max-width: 880px;\n  margin: 8px auto 0;\n  padding: 8px 10px;\n  border: 1px solid var(--tg-border, #dfe7ef);\n  border-radius: 14px;\n  background: var(--tg-panel, #fff);\n}\n\n.emoji-choice {\n  border: 0;\n  border-radius: 999px;\n  background: rgba(42, 171, 238, 0.12);\n  padding: 6px 9px;\n  cursor: pointer;\n}\n\n.chats-lightbox {\n  position: fixed;\n  inset: 0;\n  z-index: 3000;\n  display: grid;\n  place-items: center;\n  padding: 18px;\n  background: rgba(14, 22, 33, 0.78);\n}\n\n.chats-lightbox-content {\n  position: relative;\n  max-width: min(960px, 96vw);\n  max-height: 92dvh;\n  display: grid;\n  gap: 10px;\n}\n\n.chats-lightbox-close {\n  position: absolute;\n  top: 10px;\n  right: 10px;\n  width: 36px;\n  height: 36px;\n  border: 0;\n  border-radius: 50%;\n  color: #ffffff;\n  background: rgba(14, 22, 33, 0.72);\n  cursor: pointer;\n}\n\n.chats-lightbox-image {\n  max-width: 100%;\n  max-height: 86dvh;\n  border-radius: 12px;\n  object-fit: contain;\n}\n\n.chats-lightbox-caption {\n  color: #ffffff;\n  text-align: center;\n}\n\n.composer-shell,\n.composer-editing {\n  background: var(--tg-panel);\n  border: 1px solid var(--tg-border);\n  box-shadow: none;\n}\n\n.composer-editing.reply {\n  border-left: 3px solid var(--tg-accent);\n}\n\n.forward-list {\n  max-height: min(460px, 70dvh);\n  overflow: auto;\n}\n\n.forward-chat-row {\n  width: 100%;\n  border: 0;\n  background: transparent;\n  color: var(--tg-text);\n  border-radius: 12px;\n  padding: 10px;\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.chat-avatar.small {\n  width: 34px;\n  height: 34px;\n  font-size: 13px;\n}\n\n.chat-toast {\n  position: fixed;\n  left: 50%;\n  bottom: 28px;\n  transform: translateX(-50%);\n  z-index: 2000;\n  border-radius: 999px;\n  padding: 10px 16px;\n  color: #fff;\n  background: rgba(23, 33, 43, 0.88);\n}\n\nbody[data-theme=\"dark\"] .chats-page {\n  --chat-page-bg:\n    radial-gradient(circle at top left, rgba(255, 255, 255, 0.08), transparent 24%),\n    linear-gradient(180deg, #10263f 0%, #0d2238 38%, #09192b 100%);\n  --chat-shell-surface: rgba(17, 28, 43, 0.88);\n  --chat-shell-border: rgba(125, 167, 214, 0.12);\n  --chat-shell-shadow: 0 24px 64px rgba(1, 8, 17, 0.48);\n  --chat-text: #e6edf7;\n  --chat-muted: #9eb3cc;\n  --chat-strong: #f4f8fe;\n  --chat-soft-surface: rgba(255, 255, 255, 0.08);\n  --chat-soft-surface-2: rgba(18, 31, 48, 0.92);\n  --chat-soft-hover: rgba(255, 255, 255, 0.06);\n  --chat-active: rgba(255, 255, 255, 0.08);\n  --chat-active-ring: inset 0 0 0 1px rgba(122, 169, 223, 0.18);\n  --chat-header-bg: rgba(17, 28, 43, 0.92);\n  --chat-header-border: rgba(125, 167, 214, 0.12);\n  --chat-panel-bg:\n    linear-gradient(rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.02)),\n    radial-gradient(circle at top left, rgba(255, 255, 255, 0.04), transparent 22%);\n  --chat-bubble-other: rgba(255, 255, 255, 0.08);\n  --chat-bubble-mine: linear-gradient(180deg, #2b84d6, #16589f);\n  --chat-composer-bg: rgba(17, 28, 43, 0.92);\n  --chat-modal-bg: #111e2f;\n  --chat-modal-overlay: rgba(2, 8, 16, 0.6);\n}\n\n.chats-shell {\n  display: grid;\n  grid-template-columns: 356px minmax(0, 1fr);\n  gap: 16px;\n  min-height: 100vh;\n  max-width: 1360px;\n  margin: 0 auto;\n  padding: 14px;\n  box-sizing: border-box;\n}\n\n.chats-sidebar,\n.chats-main {\n  min-height: 0;\n  border-radius: 28px;\n  border: 1px solid rgba(255, 255, 255, 0.46);\n  background: rgba(245, 249, 255, 0.78);\n  backdrop-filter: blur(14px);\n  box-shadow: 0 22px 60px rgba(15, 58, 109, 0.16);\n}\n\n.chats-sidebar {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n}\n\n.chats-sidebar-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 18px 18px 10px;\n}\n\n.chats-brand {\n  font-size: 12px;\n  letter-spacing: 0.18em;\n  font-weight: 800;\n  color: rgba(18, 35, 56, 0.58);\n}\n\n.chats-sidebar-title {\n  margin-top: 4px;\n  font-size: 28px;\n  line-height: 1;\n  font-weight: 800;\n  color: #0f2843;\n}\n\n.round-action,\n.icon-button,\n.composer-send,\n.jump-to-bottom,\n.sheet-primary,\n.messages-loadmore {\n  border: 0;\n  cursor: pointer;\n  transition: transform 0.18s ease, opacity 0.18s ease, background 0.18s ease;\n}\n\n.round-action,\n.icon-button,\n.composer-tool,\n.composer-send,\n.jump-to-bottom {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.round-action:hover,\n.icon-button:hover,\n.composer-send:hover,\n.jump-to-bottom:hover,\n.sheet-primary:hover,\n.messages-loadmore:hover {\n  transform: translateY(-1px);\n}\n\n.round-action {\n  width: 44px;\n  height: 44px;\n  border-radius: 22px;\n  font-size: 28px;\n  line-height: 1;\n}\n\n.round-action.primary {\n  background: linear-gradient(180deg, #2f9bff, #177ce2);\n  color: #fff;\n  box-shadow: 0 12px 26px rgba(21, 110, 199, 0.25);\n}\n\n.chats-search-wrap {\n  padding: 10px 18px 14px;\n}\n\n.chats-input,\n.composer-input {\n  width: 100%;\n  box-sizing: border-box;\n  border: 1px solid rgba(23, 60, 94, 0.14);\n  background: rgba(255, 255, 255, 0.92);\n  color: #173251;\n  border-radius: 18px;\n  padding: 13px 15px;\n  font-size: 15px;\n  outline: none;\n  transition: border-color 0.18s ease, box-shadow 0.18s ease, background 0.18s ease;\n}\n\n.chats-input:focus,\n.composer-input:focus {\n  border-color: rgba(31, 136, 233, 0.6);\n  box-shadow: 0 0 0 4px rgba(62, 153, 238, 0.12);\n  background: #fff;\n}\n\n.chats-search {\n  padding-left: 16px;\n}\n\n.chats-list {\n  flex: 1;\n  overflow: auto;\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  padding: 0 10px 12px;\n}\n\n.chat-row {\n  display: grid;\n  grid-template-columns: 52px minmax(0, 1fr);\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n  padding: 12px 12px;\n  border: 0;\n  border-radius: 22px;\n  background: transparent;\n  color: inherit;\n  text-align: left;\n}\n\n.chat-row:hover {\n  background: rgba(255, 255, 255, 0.52);\n}\n\n.chat-row.active {\n  background: rgba(255, 255, 255, 0.88);\n  box-shadow: inset 0 0 0 1px rgba(63, 144, 224, 0.18);\n}\n\n.chat-avatar {\n  width: 52px;\n  height: 52px;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background:\n    radial-gradient(circle at 28% 22%, rgba(255, 255, 255, 0.68), transparent 34%),\n    linear-gradient(160deg, #4db5ff, #1e82ea 72%);\n  color: #fff;\n  font-size: 18px;\n  font-weight: 800;\n  letter-spacing: 0.04em;\n  box-shadow: 0 10px 20px rgba(29, 125, 216, 0.24);\n}\n\n.chat-avatar.large {\n  width: 44px;\n  height: 44px;\n  font-size: 15px;\n}\n\n.chat-row-body {\n  min-width: 0;\n  display: grid;\n  gap: 5px;\n}\n\n.chat-row-top,\n.chat-row-bottom {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.chat-row-top {\n  justify-content: space-between;\n}\n\n.chat-row-title {\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 16px;\n  font-weight: 700;\n  color: #0f2843;\n}\n\n.chat-row-time {\n  flex: 0 0 auto;\n  font-size: 12px;\n  color: #6484a7;\n}\n\n.chat-row-preview {\n  min-width: 0;\n  flex: 1;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 13px;\n  color: #5b7898;\n}\n\n.chat-unread-badge {\n  min-width: 22px;\n  height: 22px;\n  padding: 0 7px;\n  border-radius: 11px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: #1d93ff;\n  color: #fff;\n  font-size: 12px;\n  font-weight: 800;\n}\n\n.chats-main {\n  position: relative;\n  display: grid;\n  grid-template-rows: auto minmax(0, 1fr) auto;\n  overflow: hidden;\n}\n\n.chats-header {\n  position: sticky;\n  top: 0;\n  z-index: 4;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 14px 18px;\n  background: rgba(234, 244, 255, 0.82);\n  border-bottom: 1px solid rgba(25, 71, 116, 0.08);\n  backdrop-filter: blur(14px);\n}\n\n.chats-header-main {\n  min-width: 0;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n}\n\n.header-actions {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n\n.chats-header-text {\n  min-width: 0;\n}\n\n.chats-header-name {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  font-size: 18px;\n  font-weight: 800;\n  color: #112943;\n}\n\n.chats-header-meta {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  margin-top: 2px;\n  font-size: 13px;\n  color: #6282a4;\n}\n\n.icon-button {\n  width: 38px;\n  height: 38px;\n  border-radius: 19px;\n  background: rgba(255, 255, 255, 0.78);\n  color: #1a4c7a;\n  font-size: 18px;\n  font-weight: 700;\n}\n\n.ui-icon {\n  width: 20px;\n  height: 20px;\n  display: block;\n  flex: 0 0 auto;\n}\n\n.visually-hidden {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n}\n\n.messages-panel {\n  position: relative;\n  overflow: auto;\n  padding: 12px 14px 12px;\n  display: flex;\n  flex-direction: column;\n  gap: 2px;\n  background:\n    linear-gradient(rgba(255, 255, 255, 0.12), rgba(255, 255, 255, 0.12)),\n    radial-gradient(circle at top left, rgba(255, 255, 255, 0.2), transparent 22%);\n}\n\n.messages-loadmore-wrap {\n  display: flex;\n  justify-content: center;\n  padding: 2px 0 10px;\n}\n\n.messages-loadmore {\n  padding: 9px 14px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.88);\n  color: #2b6598;\n  font-size: 13px;\n  font-weight: 700;\n  box-shadow: 0 10px 18px rgba(35, 88, 144, 0.08);\n}\n\n.messages-date-divider {\n  display: flex;\n  justify-content: center;\n  padding: 12px 0 8px;\n}\n\n.messages-date-divider span {\n  padding: 6px 12px;\n  border-radius: 999px;\n  background: rgba(223, 235, 248, 0.86);\n  color: #53718f;\n  font-size: 12px;\n  font-weight: 700;\n}\n\n.message-row {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 2px;\n}\n\n.message-row.mine {\n  align-items: flex-end;\n}\n\n.message-row.other {\n  align-items: flex-start;\n}\n\n.message-row.starts-group {\n  margin-top: 6px;\n}\n\n.message-row.ends-group {\n  margin-bottom: 10px;\n}\n\n.message-row.focused .message-bubble {\n  box-shadow: 0 0 0 2px rgba(18, 121, 222, 0.24), 0 12px 24px rgba(37, 92, 146, 0.12);\n}\n\n.message-author {\n  margin: 0 0 4px 12px;\n  font-size: 12px;\n  font-weight: 700;\n  color: #4c7eb2;\n}\n\n.message-bubble {\n  max-width: min(78%, 620px);\n  padding: 10px 12px 8px;\n  border-radius: 20px;\n  box-shadow: 0 12px 24px rgba(37, 92, 146, 0.12);\n}\n\n.message-bubble.other {\n  border-top-left-radius: 8px;\n  background: rgba(255, 255, 255, 0.96);\n  color: #173251;\n}\n\n.message-bubble.mine {\n  border-top-right-radius: 8px;\n  background: linear-gradient(180deg, #42a6ff, #1b86ef);\n  color: #fff;\n}\n\n.message-bubble.deleted {\n  background: rgba(214, 224, 236, 0.85);\n  color: #60758f;\n  box-shadow: none;\n}\n\n.message-text {\n  font-size: 15px;\n  line-height: 1.42;\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.message-text.deleted {\n  font-style: italic;\n}\n\n.attachment-stack {\n  display: grid;\n  gap: 8px;\n  margin-bottom: 6px;\n}\n\n.attachment-card {\n  display: block;\n  border-radius: 16px;\n  overflow: hidden;\n  background: rgba(255, 255, 255, 0.24);\n  text-decoration: none;\n  color: inherit;\n}\n\n.attachment-card.file,\n.attachment-card.voice {\n  padding: 10px 12px;\n  background: rgba(255, 255, 255, 0.18);\n}\n\n.attachment-image,\n.attachment-video {\n  display: block;\n  width: 100%;\n  max-height: 260px;\n  object-fit: cover;\n  background: rgba(10, 31, 53, 0.08);\n}\n\n.attachment-audio {\n  width: 100%;\n  margin-top: 8px;\n}\n\n.attachment-card.voice {\n  display: grid;\n  grid-template-columns: 40px minmax(0, 1fr);\n  align-items: center;\n  gap: 10px;\n}\n\n.voice-play-button {\n  width: 40px;\n  height: 40px;\n  border: 0;\n  border-radius: 50%;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  color: #fff;\n  background: var(--tg-accent);\n  cursor: pointer;\n  touch-action: manipulation;\n}\n\n.voice-play-button svg {\n  width: 19px;\n  height: 19px;\n}\n\n.voice-play-button.playing {\n  background: #128c7e;\n}\n\n.voice-loading-dot {\n  width: 16px;\n  height: 16px;\n  border: 2px solid rgba(255, 255, 255, .45);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: voice-spin .75s linear infinite;\n}\n\n.voice-content {\n  min-width: 0;\n}\n\n.voice-wave {\n  height: 24px;\n  display: flex;\n  align-items: center;\n  gap: 3px;\n  margin-top: 7px;\n}\n\n.voice-wave span {\n  width: 3px;\n  border-radius: 999px;\n  background: rgba(0, 0, 0, .28);\n}\n\n.voice-error {\n  display: block;\n  margin-top: 6px;\n  font-size: 11px;\n  color: #b3261e;\n}\n\n@keyframes voice-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.attachment-file-meta {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 10px;\n  font-size: 12px;\n}\n\n.message-links {\n  display: grid;\n  gap: 4px;\n  margin-top: 6px;\n}\n\n.message-link {\n  color: inherit;\n  font-size: 12px;\n  text-decoration: underline;\n  overflow-wrap: anywhere;\n}\n\n.message-meta {\n  margin-top: 4px;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 6px;\n  font-size: 11px;\n}\n\n.message-bubble.mine .message-meta {\n  color: rgba(255, 255, 255, 0.82);\n}\n\n.message-bubble.other .message-meta {\n  color: #7690aa;\n}\n\n.message-bubble.deleted .message-meta {\n  color: #60758f;\n}\n\n.message-status {\n  font-size: 12px;\n  line-height: 1;\n  letter-spacing: -0.08em;\n}\n\n.message-status.read {\n  color: #d9f0ff;\n}\n\n.message-edited-mark {\n  opacity: 0.88;\n}\n\n.message-meta-actions {\n  display: inline-flex;\n  align-items: center;\n  gap: 4px;\n  margin-left: 4px;\n}\n\n.message-action-button {\n  width: 26px;\n  height: 26px;\n  border: 0;\n  border-radius: 13px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  background: rgba(255, 255, 255, 0.22);\n  color: inherit;\n  cursor: pointer;\n  transition: background 0.18s ease, transform 0.18s ease, opacity 0.18s ease;\n}\n\n.message-action-button:hover {\n  transform: translateY(-1px);\n  background: rgba(255, 255, 255, 0.28);\n}\n\n.message-action-button.danger {\n  color: #ffd2d7;\n}\n\n.composer {\n  position: sticky;\n  bottom: 0;\n  z-index: 4;\n  padding: 10px 14px calc(12px + env(safe-area-inset-bottom));\n  background: linear-gradient(180deg, rgba(239, 247, 255, 0.2), rgba(236, 245, 255, 0.92));\n  backdrop-filter: blur(14px);\n}\n\n.composer-shell {\n  display: grid;\n  grid-template-columns: auto auto minmax(0, 1fr) auto auto;\n  gap: 10px;\n  align-items: flex-end;\n  padding: 8px;\n  border-radius: 24px;\n  background: rgba(255, 255, 255, 0.88);\n  box-shadow: 0 18px 36px rgba(37, 88, 141, 0.16);\n}\n\n.composer-editing {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 8px;\n  padding: 10px 12px;\n  border-radius: 18px;\n  background: rgba(255, 255, 255, 0.82);\n  box-shadow: 0 12px 28px rgba(37, 88, 141, 0.12);\n}\n\n.composer-editing-copy {\n  min-width: 0;\n  display: grid;\n  gap: 2px;\n}\n\n.composer-editing-copy strong {\n  font-size: 13px;\n  color: #173251;\n}\n\n.composer-editing-copy span {\n  font-size: 12px;\n  color: #53718f;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.composer-editing-cancel {\n  border: 0;\n  background: transparent;\n  color: #1d70c8;\n  font-size: 13px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.composer-input {\n  min-height: 22px;\n  max-height: 136px;\n  resize: none;\n  border: 0;\n  background: transparent;\n  padding: 8px 10px;\n  box-shadow: none;\n}\n\n.composer-input:focus {\n  box-shadow: none;\n}\n\n.composer-file-input {\n  display: none;\n}\n\n.composer-tool {\n  width: 40px;\n  height: 40px;\n  border: 0;\n  border-radius: 20px;\n  background: rgba(23, 92, 155, 0.08);\n  color: #1d70c8;\n  font-size: 16px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.composer-tool.recording {\n  background: rgba(214, 63, 83, 0.14);\n  color: #c3384e;\n}\n\n.composer-send {\n  width: 44px;\n  height: 44px;\n  border-radius: 22px;\n  background: linear-gradient(180deg, #32a0ff, #1279de);\n  color: #fff;\n  font-size: 18px;\n  font-weight: 800;\n}\n\n.composer-send:disabled {\n  opacity: 0.45;\n  cursor: default;\n  transform: none;\n}\n\n.jump-to-bottom {\n  position: absolute;\n  right: 20px;\n  bottom: calc(88px + env(safe-area-inset-bottom));\n  z-index: 5;\n  width: 42px;\n  height: 42px;\n  border-radius: 21px;\n  background: rgba(255, 255, 255, 0.94);\n  color: #1d70c8;\n  font-size: 18px;\n  font-weight: 800;\n  box-shadow: 0 14px 28px rgba(33, 84, 135, 0.22);\n}\n\n.chats-empty {\n  padding: 22px 18px;\n  text-align: center;\n  color: #53718f;\n}\n\n.chats-main-empty {\n  align-self: center;\n}\n\n.chats-error {\n  color: #b53948;\n}\n\n.chats-modal {\n  position: fixed;\n  inset: 0;\n  z-index: 25;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding: 16px;\n  background: rgba(11, 32, 56, 0.32);\n  backdrop-filter: blur(6px);\n}\n\n.chats-modal-sheet {\n  width: min(100%, 460px);\n  border-radius: 28px;\n  background: #f4f9ff;\n  box-shadow: 0 28px 60px rgba(15, 47, 83, 0.28);\n  padding: 10px 16px 18px;\n}\n\n.chats-modal-handle {\n  width: 44px;\n  height: 5px;\n  border-radius: 999px;\n  margin: 4px auto 10px;\n  background: rgba(75, 108, 140, 0.28);\n}\n\n.chats-modal-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 12px;\n}\n\n.chats-modal-title {\n  font-size: 20px;\n  font-weight: 800;\n  color: #0f2843;\n}\n\n.sheet-form {\n  display: grid;\n  gap: 10px;\n}\n\n.sheet-primary.compact {\n  min-height: 44px;\n  padding: 0 16px;\n}\n\n.sheet-secondary {\n  min-height: 48px;\n  border: 0;\n  border-radius: 18px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  background: rgba(255, 255, 255, 0.88);\n  color: #173251;\n  font-size: 15px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.sheet-secondary.danger {\n  color: #c3384e;\n}\n\n.search-row {\n  display: grid;\n  grid-template-columns: minmax(0, 1fr) auto;\n  gap: 10px;\n}\n\n.sheet-results,\n.media-list {\n  display: grid;\n  gap: 8px;\n  max-height: 54vh;\n  overflow: auto;\n}\n\n.sheet-result,\n.media-list-item {\n  width: 100%;\n  text-align: left;\n  border: 0;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.9);\n  padding: 12px;\n  color: inherit;\n}\n\n.sheet-result-title {\n  font-size: 14px;\n  font-weight: 700;\n  color: #14304d;\n}\n\n.sheet-result-meta {\n  margin-top: 4px;\n  font-size: 12px;\n  color: #6e89a3;\n}\n\n.media-tabs {\n  display: flex;\n  gap: 8px;\n  overflow: auto;\n  margin-bottom: 12px;\n}\n\n.media-tab,\n.counter-chip {\n  border: 0;\n  border-radius: 999px;\n  background: rgba(29, 112, 200, 0.1);\n  color: #1d70c8;\n  font-size: 13px;\n  font-weight: 700;\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.media-tab.active {\n  background: #1d70c8;\n  color: #fff;\n}\n\n.settings-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 12px;\n  padding: 10px 12px;\n  border-radius: 16px;\n  background: rgba(255, 255, 255, 0.85);\n  color: #173251;\n  font-size: 14px;\n}\n\n.settings-row input[type=\"checkbox\"] {\n  accent-color: #1d70c8;\n}\n\n.settings-counters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.sheet-primary {\n  min-height: 48px;\n  border-radius: 18px;\n  background: linear-gradient(180deg, #2fa0ff, #197fe6);\n  color: #fff;\n  font-size: 15px;\n  font-weight: 800;\n}\n\n.sheet-primary:disabled {\n  opacity: 0.55;\n  cursor: default;\n  transform: none;\n}\n\n.hidden {\n  display: none;\n}\n\nbody[data-theme=\"dark\"] .chats-sidebar,\nbody[data-theme=\"dark\"] .chats-main {\n  border-color: rgba(125, 167, 214, 0.12);\n  background: rgba(17, 28, 43, 0.88);\n  box-shadow: 0 24px 64px rgba(1, 8, 17, 0.48);\n}\n\nbody[data-theme=\"dark\"] .chats-brand,\nbody[data-theme=\"dark\"] .chat-row-time,\nbody[data-theme=\"dark\"] .chat-row-preview,\nbody[data-theme=\"dark\"] .chats-header-meta,\nbody[data-theme=\"dark\"] .chats-empty,\nbody[data-theme=\"dark\"] .sheet-result-meta {\n  color: #9eb3cc;\n}\n\nbody[data-theme=\"dark\"] .chats-sidebar-title,\nbody[data-theme=\"dark\"] .chat-row-title,\nbody[data-theme=\"dark\"] .chats-header-name,\nbody[data-theme=\"dark\"] .chats-modal-title,\nbody[data-theme=\"dark\"] .sheet-result-title,\nbody[data-theme=\"dark\"] .settings-row,\nbody[data-theme=\"dark\"] .media-list-item {\n  color: #f4f8fe;\n}\n\nbody[data-theme=\"dark\"] .chat-row:hover {\n  background: rgba(255, 255, 255, 0.06);\n}\n\nbody[data-theme=\"dark\"] .chat-row.active {\n  background: rgba(255, 255, 255, 0.08);\n  box-shadow: inset 0 0 0 1px rgba(122, 169, 223, 0.18);\n}\n\nbody[data-theme=\"dark\"] .chats-input,\nbody[data-theme=\"dark\"] .composer-shell,\nbody[data-theme=\"dark\"] .sheet-result,\nbody[data-theme=\"dark\"] .media-list-item,\nbody[data-theme=\"dark\"] .settings-row,\nbody[data-theme=\"dark\"] .messages-loadmore,\nbody[data-theme=\"dark\"] .icon-button,\nbody[data-theme=\"dark\"] .composer-tool,\nbody[data-theme=\"dark\"] .jump-to-bottom,\nbody[data-theme=\"dark\"] .counter-chip,\nbody[data-theme=\"dark\"] .media-tab {\n  background: rgba(255, 255, 255, 0.08);\n  color: #e6edf7;\n  border-color: rgba(125, 167, 214, 0.12);\n}\n\nbody[data-theme=\"dark\"] .chats-input,\nbody[data-theme=\"dark\"] .composer-input {\n  color: #e6edf7;\n  border-color: rgba(125, 167, 214, 0.14);\n}\n\nbody[data-theme=\"dark\"] .chats-header {\n  background: rgba(17, 28, 43, 0.92);\n  border-bottom-color: rgba(125, 167, 214, 0.12);\n}\n\nbody[data-theme=\"dark\"] .messages-panel {\n  background:\n    linear-gradient(rgba(255, 255, 255, 0.02), rgba(255, 255, 255, 0.02)),\n    radial-gradient(circle at top left, rgba(255, 255, 255, 0.04), transparent 22%);\n}\n\nbody[data-theme=\"dark\"] .message-bubble.other {\n  background: rgba(255, 255, 255, 0.08);\n  color: #e6edf7;\n}\n\nbody[data-theme=\"dark\"] .message-bubble.deleted {\n  background: rgba(255, 255, 255, 0.08);\n  color: #9eb3cc;\n}\n\nbody[data-theme=\"dark\"] .message-bubble.mine {\n  background: linear-gradient(180deg, #2b84d6, #16589f);\n}\n\nbody[data-theme=\"dark\"] .message-bubble.other .message-meta,\nbody[data-theme=\"dark\"] .message-author,\nbody[data-theme=\"dark\"] .messages-date-divider span {\n  color: #9eb3cc;\n}\n\nbody[data-theme=\"dark\"] .message-bubble.deleted .message-meta {\n  color: #9eb3cc;\n}\n\nbody[data-theme=\"dark\"] .messages-date-divider span {\n  background: rgba(255, 255, 255, 0.08);\n}\n\nbody[data-theme=\"dark\"] .composer {\n  background: linear-gradient(180deg, rgba(17, 28, 43, 0.25), rgba(17, 28, 43, 0.96));\n}\n\nbody[data-theme=\"dark\"] .chats-modal {\n  background: rgba(2, 8, 16, 0.6);\n}\n\nbody[data-theme=\"dark\"] .chats-modal-sheet {\n  background: #111e2f;\n}\n\nbody[data-theme=\"dark\"] .attachment-card,\nbody[data-theme=\"dark\"] .attachment-card.file,\nbody[data-theme=\"dark\"] .attachment-card.voice {\n  background: rgba(255, 255, 255, 0.08);\n}\n\nbody[data-theme=\"dark\"] .message-action-button,\nbody[data-theme=\"dark\"] .sheet-secondary,\nbody[data-theme=\"dark\"] .composer-editing {\n  background: rgba(255, 255, 255, 0.08);\n  color: #e6edf7;\n}\n\nbody[data-theme=\"dark\"] .composer-editing-copy strong {\n  color: #f4f8fe;\n}\n\nbody[data-theme=\"dark\"] .composer-editing-copy span {\n  color: #9eb3cc;\n}\n\nbody[data-theme=\"dark\"] .composer-editing-cancel {\n  color: #8dc8ff;\n}\n\nbody[data-theme=\"dark\"] .message-action-button.danger,\nbody[data-theme=\"dark\"] .sheet-secondary.danger {\n  color: #ffb5bf;\n}\n\nbody[data-theme=\"dark\"] .attachment-image,\nbody[data-theme=\"dark\"] .attachment-video {\n  background: rgba(255, 255, 255, 0.06);\n}\n\nbody[data-theme=\"dark\"] .message-status.read {\n  color: #8dd7ff;\n}\n\n@media (max-width: 980px) {\n  .chats-shell {\n    grid-template-columns: 320px minmax(0, 1fr);\n    padding: 10px;\n  }\n\n  .message-bubble {\n    max-width: 88%;\n  }\n}\n\n@media (max-width: 767px) {\n  .chats-page {\n    background: var(--chat-page-bg);\n  }\n\n  .chats-shell {\n    display: block;\n    padding: 0;\n  }\n\n  .chats-sidebar,\n  .chats-main {\n    min-height: 100vh;\n    border-radius: 0;\n    border: 0;\n    box-shadow: none;\n  }\n\n  .chats-sidebar-top {\n    padding-top: calc(16px + env(safe-area-inset-top));\n  }\n\n  .chats-header {\n    padding-top: calc(12px + env(safe-area-inset-top));\n  }\n\n  .messages-panel {\n    padding-left: 10px;\n    padding-right: 10px;\n  }\n\n  .message-bubble {\n    max-width: 92%;\n  }\n\n  .jump-to-bottom {\n    right: 14px;\n    bottom: calc(84px + env(safe-area-inset-bottom));\n  }\n\n  .chats-modal {\n    padding: 0;\n    align-items: flex-end;\n  }\n\n  .chats-modal-sheet {\n    width: 100%;\n    border-bottom-left-radius: 0;\n    border-bottom-right-radius: 0;\n    padding-bottom: calc(18px + env(safe-area-inset-bottom));\n  }\n}\n\n/* Final Telegram-like overrides */\n.chats-page {\n  background: var(--tg-bg, #e7eef5);\n  color: var(--tg-text, #17212b);\n}\n\n.chats-shell {\n  grid-template-columns: minmax(300px, 368px) minmax(0, 1fr);\n  gap: 0;\n  max-width: none;\n  min-height: 100dvh;\n  padding: 0;\n}\n\n.chats-sidebar,\n.chats-main {\n  border: 0;\n  border-radius: 0;\n  box-shadow: none;\n  backdrop-filter: none;\n}\n\n.chats-sidebar {\n  background: var(--tg-sidebar, #fff);\n  border-right: 1px solid var(--tg-border, #dfe7ef);\n}\n\n.chats-main {\n  background:\n    linear-gradient(rgba(231, 238, 245, 0.84), rgba(231, 238, 245, 0.84)),\n    repeating-linear-gradient(45deg, rgba(42, 171, 238, 0.04) 0 1px, transparent 1px 18px);\n}\n\n.chat-row {\n  border-radius: 0;\n  border: 0;\n}\n\n.message-bubble.other {\n  background: var(--tg-bubble-other, #fff);\n}\n\n.message-bubble.mine {\n  background: var(--tg-bubble-mine, #effdde);\n  color: var(--tg-text, #17212b);\n}\n\n.composer {\n  background: transparent;\n}\n\n/* EOF override: keep ordinary support /chats in native messenger mode. */\n.pageContentInner:has(> .chats-page) {\n  padding: 0 !important;\n}\n\n.chats-page {\n  --tg-bg: #dbe7f3;\n  --tg-sidebar: #fff;\n  --tg-panel: #fff;\n  --tg-header: #fff;\n  --tg-border: #d3dde8;\n  --tg-text: #17212b;\n  --tg-muted: #6d7f90;\n  --tg-accent: #2aabee;\n  --tg-bubble-other: #fff;\n  --tg-bubble-mine: #dff7c7;\n  --tg-input: #fff;\n  --tg-skeleton-base: rgba(23, 33, 43, .08);\n  --tg-skeleton-peak: rgba(255, 255, 255, .72);\n  height: calc(var(--vh, 1vh) * 100) !important;\n  min-height: 0 !important;\n  overflow: hidden !important;\n  background: var(--tg-bg) !important;\n  color: var(--tg-text) !important;\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Arial, sans-serif !important;\n}\n\nbody[data-theme=\"dark\"] .chats-page {\n  --tg-bg: #0e1621;\n  --tg-sidebar: #17212b;\n  --tg-panel: #17212b;\n  --tg-header: #17212b;\n  --tg-border: #0b1118;\n  --tg-text: #eef6fc;\n  --tg-muted: #7f91a4;\n  --tg-bubble-other: #182533;\n  --tg-bubble-mine: #2b5278;\n  --tg-input: #242f3d;\n  --tg-skeleton-base: rgba(255, 255, 255, .07);\n  --tg-skeleton-peak: rgba(255, 255, 255, .16);\n}\n\n.chats-shell {\n  width: 100% !important;\n  height: 100% !important;\n  min-height: 0 !important;\n  max-width: none !important;\n  display: grid !important;\n  grid-template-columns: 360px minmax(0, 1fr) !important;\n  gap: 0 !important;\n  margin: 0 !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n}\n\n.chats-sidebar,\n.chats-main {\n  min-height: 0 !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  box-shadow: none !important;\n  backdrop-filter: none !important;\n}\n\n.chats-sidebar {\n  display: flex !important;\n  flex-direction: column !important;\n  padding: 0 !important;\n  overflow: hidden !important;\n  background: var(--tg-sidebar) !important;\n  border-right: 1px solid var(--tg-border) !important;\n}\n\n.chats-main {\n  position: relative !important;\n  display: grid !important;\n  grid-template-rows: 56px auto minmax(0, 1fr) auto !important;\n  overflow: hidden !important;\n  background:\n    linear-gradient(rgba(219, 231, 243, .84), rgba(219, 231, 243, .84)),\n    radial-gradient(circle at 24px 24px, rgba(49, 102, 139, .075) 0 1.2px, transparent 1.4px),\n    radial-gradient(circle at 76px 84px, rgba(49, 102, 139, .055) 0 1.6px, transparent 1.8px) !important;\n  background-size: auto, 68px 68px, 112px 112px !important;\n}\n\nbody[data-theme=\"dark\"] .chats-main {\n  background:\n    linear-gradient(rgba(14, 22, 33, .9), rgba(14, 22, 33, .9)),\n    radial-gradient(circle at 24px 24px, rgba(255, 255, 255, .045) 0 1.2px, transparent 1.4px),\n    radial-gradient(circle at 76px 84px, rgba(255, 255, 255, .035) 0 1.6px, transparent 1.8px) !important;\n}\n\n.chats-sidebar-top,\n.chats-header {\n  height: 56px !important;\n  min-height: 56px !important;\n  padding: 0 12px !important;\n  background: var(--tg-header) !important;\n  border-bottom: 1px solid var(--tg-border) !important;\n}\n\n.chats-brand {\n  display: none !important;\n}\n\n.chats-sidebar-title {\n  color: var(--tg-text) !important;\n  font-size: 19px !important;\n  font-weight: 700 !important;\n}\n\n.round-action,\n.icon-button,\n.composer-tool,\n.jump-to-bottom,\n.message-action-button {\n  width: 40px !important;\n  height: 40px !important;\n  min-width: 40px !important;\n  border: 0 !important;\n  border-radius: 50% !important;\n  color: var(--tg-muted) !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.round-action:hover,\n.icon-button:hover,\n.icon-button.active,\n.composer-tool:hover {\n  color: var(--tg-accent) !important;\n  background: rgba(42, 171, 238, .12) !important;\n}\n\n.chats-search-wrap,\n.chats-filter-row,\n.chats-list {\n  background: var(--tg-sidebar) !important;\n}\n\n.chats-search {\n  height: 36px !important;\n  border: 0 !important;\n  border-radius: 18px !important;\n  background: var(--tg-input) !important;\n}\n\n.chat-filter-chip {\n  min-height: 30px !important;\n  border: 0 !important;\n  border-radius: 15px !important;\n  color: var(--tg-muted) !important;\n  background: transparent !important;\n}\n\n.chat-filter-chip.active {\n  color: var(--tg-accent) !important;\n  background: rgba(42, 171, 238, .14) !important;\n}\n\n.chats-list {\n  flex: 1 !important;\n  min-height: 0 !important;\n  gap: 0 !important;\n  padding: 0 !important;\n  overflow: auto !important;\n}\n\n.chat-row,\n.chat-row-skeleton {\n  position: relative !important;\n  width: 100% !important;\n  min-height: 72px !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  grid-template-columns: 54px minmax(0, 1fr) auto !important;\n  gap: 10px !important;\n  padding: 8px 12px !important;\n  color: var(--tg-text) !important;\n  background: transparent !important;\n}\n\n.chat-row::after,\n.chat-row-skeleton::after {\n  content: \"\" !important;\n  position: absolute !important;\n  left: 76px !important;\n  right: 0 !important;\n  bottom: 0 !important;\n  height: 1px !important;\n  background: rgba(23, 33, 43, .08) !important;\n}\n\n.chat-row:hover {\n  background: rgba(42, 171, 238, .07) !important;\n}\n\n.chat-row.active {\n  background: rgba(42, 171, 238, .14) !important;\n}\n\n.chat-avatar,\n.skeleton-avatar {\n  width: 50px !important;\n  height: 50px !important;\n  border-radius: 50% !important;\n}\n\n.chat-row-title {\n  color: var(--tg-text) !important;\n  font-size: 15px !important;\n  font-weight: 600 !important;\n}\n\n.chat-row-preview,\n.chat-row-time {\n  color: var(--tg-muted) !important;\n  font-size: 13px !important;\n}\n\n.messages-panel {\n  min-height: 0 !important;\n  padding: 14px max(12px, calc((100% - 920px) / 2)) 10px !important;\n  overflow: auto !important;\n  scroll-behavior: smooth !important;\n}\n\n.messages-date-divider span {\n  min-height: 26px !important;\n  border-radius: 13px !important;\n  padding: 0 12px !important;\n  background: rgba(109, 127, 144, .58) !important;\n  backdrop-filter: blur(8px) !important;\n}\n\n.message-row.mine {\n  align-items: flex-end !important;\n}\n\n.message-row.other {\n  align-items: flex-start !important;\n}\n\n.message-bubble {\n  max-width: min(620px, 78%) !important;\n  border: 0 !important;\n  border-radius: 11px !important;\n  padding: 6px 8px 4px !important;\n  color: var(--tg-text) !important;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, .18) !important;\n  animation: telegram-message-in .2s cubic-bezier(.18, .9, .22, 1.12) both !important;\n}\n\n.message-bubble.other {\n  border-bottom-left-radius: 3px !important;\n  background: var(--tg-bubble-other) !important;\n}\n\n.message-bubble.mine {\n  border-bottom-right-radius: 3px !important;\n  background: var(--tg-bubble-mine) !important;\n}\n\n.message-text {\n  color: var(--tg-text) !important;\n  font-size: 16px !important;\n  line-height: 1.36 !important;\n}\n\n.composer {\n  position: sticky !important;\n  bottom: 0 !important;\n  z-index: 4 !important;\n  border: 0 !important;\n  padding: 7px max(8px, calc((100% - 940px) / 2)) 10px !important;\n  background: linear-gradient(180deg, rgba(219, 231, 243, 0), rgba(219, 231, 243, .96) 22%) !important;\n}\n\n.composer-shell {\n  width: 100% !important;\n  max-width: none !important;\n  border: 0 !important;\n  border-radius: 0 !important;\n  display: grid !important;\n  grid-template-columns: 40px 40px minmax(0, 1fr) 40px 46px !important;\n  align-items: end !important;\n  gap: 6px !important;\n  margin: 0 !important;\n  background: transparent !important;\n  box-shadow: none !important;\n}\n\n.composer-input {\n  min-height: 42px !important;\n  max-height: 140px !important;\n  border: 0 !important;\n  border-radius: 21px !important;\n  resize: none !important;\n  padding: 11px 14px !important;\n  background: var(--tg-input) !important;\n  color: var(--tg-text) !important;\n  font-size: 15px !important;\n}\n\n.composer-send {\n  width: 44px !important;\n  height: 44px !important;\n  min-width: 44px !important;\n  border: 0 !important;\n  border-radius: 50% !important;\n  background: var(--tg-accent) !important;\n  color: #fff !important;\n  box-shadow: none !important;\n}\n\n.composer-editing,\n.composer-attachments,\n.emoji-panel {\n  grid-column: 1 / -1 !important;\n}\n\n.jump-to-bottom {\n  position: absolute !important;\n  right: max(16px, calc((100% - 920px) / 2)) !important;\n  bottom: 74px !important;\n  z-index: 8 !important;\n  background: var(--tg-panel) !important;\n  box-shadow: 0 4px 14px rgba(23, 33, 43, .18) !important;\n}\n\n.chats-empty {\n  border-radius: 14px !important;\n  padding: 16px 18px !important;\n  color: var(--tg-muted) !important;\n  background: rgba(255, 255, 255, .78) !important;\n}\n\n.settings-status {\n  color: var(--tg-muted);\n  font-size: 13px;\n  padding: 0 4px;\n}\n\n.settings-mute-options,\n.settings-counters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n}\n\n.chat-sheet,\n.chats-modal {\n  position: fixed !important;\n  inset: 0 !important;\n  z-index: 2000 !important;\n  display: grid !important;\n  place-items: end center !important;\n  padding: 0 10px calc(10px + env(safe-area-inset-bottom)) !important;\n  background: rgba(0, 0, 0, .52) !important;\n  backdrop-filter: blur(14px) !important;\n}\n\n.attachment-sheet-grid {\n  width: min(430px, 100%) !important;\n  max-height: 82dvh !important;\n  overflow: auto !important;\n  border-radius: 18px !important;\n  display: grid !important;\n  grid-template-columns: repeat(3, 1fr) !important;\n  gap: 20px 12px !important;\n  padding: 28px 18px 24px !important;\n  color: #fff !important;\n  background: rgba(33, 35, 39, .96) !important;\n}\n\n.attachment-sheet-grid button {\n  border: 0 !important;\n  display: grid !important;\n  justify-items: center !important;\n  gap: 8px !important;\n  color: #fff !important;\n  background: transparent !important;\n}\n\n.attachment-sheet-icon {\n  width: 52px !important;\n  height: 52px !important;\n  border-radius: 50% !important;\n  display: inline-flex !important;\n  align-items: center !important;\n  justify-content: center !important;\n  color: #fff !important;\n}\n\n.attachment-sheet-icon.blue { background: linear-gradient(135deg, #2f80ed, #3b9bff) !important; }\n.attachment-sheet-icon.purple { background: linear-gradient(135deg, #7c3aed, #a855f7) !important; }\n.attachment-sheet-icon.orange { background: linear-gradient(135deg, #f59e0b, #fb923c) !important; }\n\n.attachment-sheet-cancel {\n  width: min(430px, 100%) !important;\n  min-height: 54px !important;\n  border: 0 !important;\n  border-radius: 14px !important;\n  color: var(--tg-accent) !important;\n  background: rgba(33, 35, 39, .96) !important;\n  font-size: 16px !important;\n}\n\n.skeleton-avatar,\n.skeleton-line,\n.skeleton-date-pill,\n.message-skeleton-bubble {\n  position: relative !important;\n  overflow: hidden !important;\n  background: var(--tg-skeleton-base) !important;\n}\n\n.skeleton-avatar::after,\n.skeleton-line::after,\n.skeleton-date-pill::after,\n.message-skeleton-bubble::after {\n  content: \"\" !important;\n  position: absolute !important;\n  inset: 0 !important;\n  transform: translateX(-100%) !important;\n  background: linear-gradient(90deg, transparent, var(--tg-skeleton-peak), transparent) !important;\n  animation: skeleton-shimmer 1.25s ease-in-out infinite !important;\n}\n\n.message-skeleton-bubble {\n  width: min(360px, 68%) !important;\n  min-height: 56px !important;\n  border-radius: 13px !important;\n  display: grid !important;\n  align-content: center !important;\n  gap: 8px !important;\n  padding: 12px !important;\n}\n\n.message-skeleton-bubble.other {\n  align-self: flex-start !important;\n}\n\n.message-skeleton-bubble.mine {\n  align-self: flex-end !important;\n  background: rgba(91, 185, 74, .16) !important;\n}\n\n.message-skeleton-bubble.wide {\n  width: min(470px, 78%) !important;\n}\n\n@media (max-width: 760px) {\n  .chats-shell {\n    height: 100% !important;\n    grid-template-columns: 1fr !important;\n  }\n\n  .chats-sidebar.hidden,\n  .chats-main.hidden {\n    display: none !important;\n  }\n\n  .chats-sidebar {\n    border-right: 0 !important;\n  }\n\n  .chats-main {\n    height: 100% !important;\n    grid-template-rows: 56px auto minmax(0, 1fr) auto !important;\n  }\n\n  .header-actions .optional-mobile-action {\n    display: none !important;\n  }\n\n  .messages-panel {\n    padding: 10px 8px 8px !important;\n  }\n\n  .message-bubble {\n    max-width: 86% !important;\n  }\n\n  .composer {\n    padding: 6px 8px calc(8px + env(safe-area-inset-bottom)) !important;\n  }\n\n  .composer-shell {\n    grid-template-columns: 38px 38px minmax(0, 1fr) 38px 44px !important;\n    align-items: center !important;\n  }\n}\n\n.chat-screen-grid{display:flex;gap:8px;max-height:45vh;flex-shrink:0;overflow:auto;background:#142035;padding:8px}.chat-shared-screen{margin:0;flex:1;min-width:220px;color:white}.chat-shared-screen video{width:100%;max-height:36vh;background:#000;object-fit:contain}.chat-shared-screen figcaption{padding:4px;font-size:12px}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
